export const thingsToDoArr = [];

// start showsArr

// export const showsArr = [

//       {
//         title: "Pride Week 2020",
//         desc: "",
//         date: "12.06.20",
//         date2: "12.06.20",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Week-2020",
//         css_class: "unic-singer-Pride_Parade-2020",
//         id: "Pride_Week_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Nick Cave & Bad Seeds",
//         desc: "",
//         date: "17.06.20",
//         date2: "17.06.20",
//         img: "Concerts/nickcave-badseeds.jpg",
//         side_img: "Concerts/nickcave-badseeds.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Nickcave-Badseeds",
//       // id: "Nickcave_Badseeds",
//         css_class: "unic-singer-nickcave-badseeds",
//         book_now : "READ MORE"
//       },
//       {
//         title: "The Pixies",
//         desc: "",
//         date: "09.20",
//         date2: "30.09.20",
//         img: "Concerts/1.jpg",
//         side_img: "Concerts/1.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=The_Pixies.20",
//         css_class: "unic-singer-pixies.20",
//         // id: "The_Pixies_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Celine Dion",
//         desc: "",
//         date: "04.08.20",
//         date2: "04.08.20",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "unic-singer-Celine_Dion",
//         // id: "Celine_Dion",
//         book_now : "READ MORE"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.20",
//         date2: "30.08.20",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "unic-singer-dgt.20",
//         id: "DGTL_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Hutzot Hayotzer Gerusalemme",
//         desc: "",
//         date: "08.20",
//         date2: "30.08.20",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem.20",
//         css_class: "unic-singer-hutzot_hayotzer",
//         id: "Hutzot_Hayotzer_Jerusalem_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Festival della birra di Gerusalemme",
//         desc: "",
//         date: "08.20",
//         date2: "30.08.20",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival.20",
//         css_class: "unic-singer-jbf-2020",
//         id: "Jerusalem_Beer_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Wine Festival",
//         desc: "",
//         date: "08.20",
//         date2: "30.08.20",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Jerusalem Wine Festival.20",
//         css_class: "unic-singer-jwf-2020",
//         id: "Jerusalem_Wine_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "09.20",
//         date2: "30.09.20",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival.20",
//         css_class: "unic-singer-openhf-2020",
//         id: "Open_Houses_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "The Jerusalem March",
//         desc: "",
//         date: "03.09.20",
//         date2: "03.09.20",
//         img: "Concerts/jerusalem-march.jpg",
//         side_img: "Concerts/jerusalem-march.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival.20",
//         css_class: "unic-singer-jerusalem-march-2020",
//         // id: "The_Jerusalem_March_2020",
//         book_now : "READ MORE"
//       },

//       // Double post for complite the SHOS carousel in mobile
//       {
//         title: "Pride Week 2020",
//         desc: "",
//         date: "12.06.20",
//         date2: "12.06.20",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Week-2020",
//         css_class: "unic-singer-Pride_Parade-2020",
//         id: "Pride_Week_2020",
//         isDouble: true,
//         book_now : "READ MORE"
//       },
//       // END Double post for complite the SHOS carousel in mobile

//       /*----------------OLD SINGERS------------------*/

//       {
//         title: "Natalia Oreiro",
//         desc: "Natalia to Wow Tel Aviv in March",
//         date: "20.03.18",
//         date2: "12.04.20",
//         img: "Concerts/32.jpg",
//         side_img: "Concerts/Sidebar/46.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=44",
//         css_class: "unic-singer-13",
//         id:44,
//         book_now: "Read More"
//       },

//        {
//         title: "Backstreet Boys",
//         desc: "The Backstreet Boys are Back and Larger Than Life",
//         date: "22.04.18",
//         date2: "12.04.20",
//         img: "Concerts/51.jpg",
//         side_img: "Concerts/Sidebar/53.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=51",
//         css_class: "unic-singer-20",
//         id:51,
//         a_star: true,
//         book_now: "Read More"
//       },

//       {
//        title: "Led Zeppelin 2",
//        desc : "Don’t Miss the Zeps in Tel Aviv!" ,
//        date : "07-10.01.18",
//        date2: "12.04.20",
//        img  : "Concerts/20.jpg",
//        side_img  : "Concerts/Sidebar/29.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=29" ,
//        css_class: "unic-singer-3",
//        id:29,
//        book_now : "Read More"
//       },

//       {
//         title: "Chris Rock",
//         desc: "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH",
//         date: "08-09.01.18",
//         date2: "12.04.20",
//         img: "Concerts/6.jpg",
//         side_img: "Concerts/Sidebar/16.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=17",
//         css_class: "unic-singer-4",
//         id:17,
//         book_now: "Read More"
//       },

//       {
//        title: "Jerry Seinfeld",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "30.12.17",
//        date2: "12.04.20",
//        img  : "Concerts/jerry.jpg",
//        side_img  : "Concerts/Sidebar/jerry.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=36" ,
//        css_class: "unic-singer-2",
//        id:36,
//        book_now : "Read More"
//       },

//       {
//        title: "Buena Vista",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "21-26.12.17",
//        date2: "12.04.20",
//        img  : "Concerts/buena.jpg",
//        side_img  : "Concerts/Sidebar/buena.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=35" ,
//        id:35,
//        book_now : "Read More"
//       },

//      {
//        title: "Justin Bieber",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.05.17",
//        date2: "12.04.20",
//        img  : "Concerts/justin.jpg",
//        side_img  : "Concerts/Sidebar/9.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=9" ,
//        a_star  : true,
//        id:9,
//        book_now : "Read More"
//       },

//       {
//        title: "AEROSMITH",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "28.06.17",
//        date2: "12.04.20",
//        img  : "Concerts/aerosmith3.jpg",
//        side_img  : "Concerts/Sidebar/10.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=10" ,
//        a_star  : true,
//        id:10,
//        book_now : "Read More"
//       },

//       {
//        title: "Britney Spears ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.07.17",
//        date2: "12.04.20",
//        img  : "Concerts/britney.jpg",
//        side_img  : "Concerts/Sidebar/2.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=2" ,
//        a_star  : true,
//        id: 2,
//        book_now : "Read More"
//       },

//       {
//        title: "Guns N' Roses",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "15.07.17",
//        date2: "12.04.20",
//        img  : "Concerts/Guns-N-roses.jpg",
//        side_img  : "Concerts/Sidebar/4.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=4" ,
//        a_star  : true,
//        id:4,
//        book_now : "Read More"
//       },

//       {
//        title: "Bryan Adams ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "04-06.12.17",
//        date2: "12.04.20",
//        img  : "Concerts/7.jpg",
//        side_img  : "Concerts/Sidebar/15.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=16" ,
//        a_star  : true,
//        id:16,
//        book_now : "Read More"
//       },

//       {
//        title: "NICK CAVE ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.11.17",
//        date2: "12.04.20",
//        img  : "Concerts/4.jpg",
//        side_img  : "Concerts/Sidebar/8.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=8" ,
//        id:8,
//        book_now : "Read More"
//       },

//       {
//         title: "RADIOHEAD ",
//         desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//         date : "19.07.17",
//         date2: "12.04.20",
//         img  : "Concerts/360x539.jpg",
//         side_img  : "Concerts/Sidebar/5.jpg" ,
//         link :  "/Posts/index.php?postType=concerts&post=5" ,
//         a_star  : true,
//         id:5,
//         book_now : "Read More"
//       },

//       {
//        title: "The Chainsmokers",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "3.08.17",
//        date2: "12.04.20",
//        img  : "Concerts/9.jpg",
//        side_img  : "Concerts/Sidebar/14.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=13" ,
//        id:13,
//        book_now : "Read More"
//       },

//       {
//        title: "Blue Man Group",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "7-23.08.17",
//        date2: "12.04.20",
//        img  : "Concerts/14.jpg",
//        side_img  : "Concerts/Sidebar/22.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=19" ,
//        id:19,
//        book_now : "Read More"
//       },

//       {
//        title: "Regina Spektor",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.08.17",
//        date2: "12.04.20",
//        img  : "Concerts/2.jpg",
//        side_img  : "Concerts/Sidebar/7.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=7" ,
//        id:7,
//        book_now : "Read More"
//       },

//       {
//        title: "Sean Paul",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "22.08.17",
//        date2: "12.04.20",
//        img  : "Concerts/13.jpg",
//        side_img  : "Concerts/Sidebar/21.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=20" ,
//       id:20,
//        a_star  : true,
//        book_now : "Read More"
//       },

//       {
//         title: "Pride Parade 2019",
//         desc: "",
//         date: "14.06.19",
//         date2: "12.04.20",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Parade_2019",
//         css_class: "unic-singer-Pride_Parade_2019",
//         id: "Pride_Parade_2019",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Daddy Yankee",
//         desc: "",
//         date: "26.06.19",
//         date2: "12.04.20",
//         img: "Concerts/daddyyanke.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-daddyyanke",
//         id: "",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Tom Jones",
//         desc: "",
//         date: "03.07.19",
//         date2: "12.04.20",
//         img: "Concerts/tomjones.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-tomjones",
//         id:1,
//         book_now : "READ MORE"
//       },

//       {
//         title: "Paul Anka",
//         desc: "",
//         date: "11.07.19",
//         date2: "12.04.20",
//         img: "Concerts/paul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-paul",
//         id:"",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Sean Paul",
//         desc: "",
//         date: "13.07.19",
//         date2: "12.04.20",
//         img: "Concerts/seanpaul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-seanpaul",
//         id:20,
//         book_now : "READ MORE"
//       },

//       {
//         title: "Ozuna",
//         desc: "",
//         date: "24.07.19",
//         date2: "12.04.20",
//         img: "Concerts/ozuna.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-ozuna",
//         id: "",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Film Festival",
//         desc: "36 Years of Cinema Magic!",
//         date: "04.08.19",
//         date2: "12.04.20",
//         img:"Concerts/filmFestive.jpg",
//         side_img:"Concerts/filmFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=68",
//         css_class: "unic-singer-68",
//         id:68,
//         book_now : "READ MORE"
//       },

//       {
//         title: "Bon Jovi",
//         desc: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
//         date: "25.07.19",
//         date2: "12.04.20",
//         img: "Concerts/bon-j.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-76",
//         id: 76,
//         book_now : "READ MORE"
//       },

//       {
//         title: "J Balvin",
//         desc: "",
//         date: "30.07.19",
//         date2: "12.04.20",
//         img: "Concerts/balvin.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-balvin",
//         id:"",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Wine Festival",
//         desc: "Wine and dine in the holy city!",
//         date: "30.07.19",
//         date2: "12.04.20",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=69",
//         css_class: "unic-singer-69",
//         id:69,
//         book_now : "READ MORE"
//       },

//       {
//         title: "J.Lo",
//         desc: "",
//         date: "01.08.19",
//         date2: "12.04.20",
//         img:"Concerts/jlo.jpg",
//         side_img:"Concerts/jlo.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jlo",
//         css_class: "unic-singer-jlo",
//         id: "J_Lo",
//         book_now : "READ MORE"
//       },

//       {
//         title: "The International Arts",
//         desc: "",
//         date: "12-24.08.19",
//         date2: "12.04.20",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=94",
//         css_class: "unic-singer-inter-arts",
//         id: "The_International_Arts",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "28-29.08.19",
//         date2: "12.04.20",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=91",
//         css_class: "unic-singer-jbf",
//         id: "Jerusalem_Beer_Festival",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Lionel Richie",
//         desc: "",
//         date: "12.09.19",
//         date2: "12.04.20",
//         img:"Concerts/lionel-richie.jpg",
//         side_img:"Concerts/lionel-richie.jpg",
//         link:"/Posts/index.php?postType=concerts&post=lionelrichie",
//         css_class: "unic-singer-lionel-richie",
//         id:"",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "19-21.09.19",
//         date2: "12.04.20",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=96",
//         css_class: "unic-singer-openhf",
//         id: "Open_Houses_Festival",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         date2: "12.04.20",
//         img: "Concerts/71.jpg",
//         side_img: "Concerts/72.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         id:"",
//         book_now : "READ MORE"
//       },
//        {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "14.10.19",
//         date2: "12.04.20",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "unic-singer-dgt.19",
//         id: "DGTL_Festival",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Cycle Tel Aviv",
//         desc: "",
//         date: "18.10.19",
//         date2: "12.04.20",
//         img: "Concerts/cycle-tlv-2019.jpg",
//         side_img: "Concerts/cycle-tlv-2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "unic-singer-cycle-tlv-2019",
//         id: "Cycle_Tel_Aviv",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Night Run Tel Aviv",
//         desc: "",
//         date: "30.10.19",
//         date2: "12.04.20",
//         img: "Concerts/night-run-tlv.jpg",
//         side_img: "Concerts/night-run-tlv.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=98",
//         css_class: "unic-singer-tlv-nightru.19",
//         id: "Night_Run_TelAviv",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Culinary Festival",
//         desc: "Special Edition: Female Chefs",
//         date: "09-23.11.19",
//         date2: "12.04.20",
//         img: "Concerts/72.jpg",
//         side_img: "Concerts/73.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=71",
//         css_class: "unic-singer-71",
//         id:"",
//         book_now : "READ MORE"
//       },

//      {
//         title: "Open Restaurants Jerusalem",
//         desc: "",
//         date: "19-23.11.19",
//         date2: "12.04.20",
//         img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         side_img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Open_Restaurants_Jerusalem",
//         css_class: "unic-singer-Open_Restaurants_Jerusalem",
//         id: "Open_Restaurants_Jerusalem",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Louis CK",
//         desc: "",
//         date: "23.11.19",
//         date2: "12.04.20",
//         img: "Concerts/Louis_CK.jpg",
//         side_img: "Concerts/Louis_CK.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Louis_CK",
//         css_class: "unic-singer-Louis_CK",
//         id: "Louis_CK",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jim Jeffries",
//         desc: "",
//         date: "21.12.19",
//         date2: "12.04.20",
//         img:"Concerts/jim-jeffries.jpg",
//         side_img:"Concerts/jim-jeffries.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jimjeffries",
//         css_class: "unic-singer-jim-jeffries",
//         id:"",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         date2: "12.04.20",
//         img:"Concerts/openRestTlv.jpg",
//         side_img:"Concerts/openRestTlv.jpg",
//         link: "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         id:70,
//         book_now : "READ MORE"
//       },
//       {
//         title: "Maratona notturna di Tel Aviv",
//         desc: "",
//         date: "28.02.20",
//         date2: "12.04.20",
//         img: "Concerts/tlv-marathon.jpg",
//         side_img: "Concerts/tlv-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=97",
//         css_class: "unic-singer-tlv-maratho.20",
//         id: "TelAviv_Marathon",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Purim.20",
//         desc: "",
//         date: "09-10.03.20",
//         date2: "12.04.20",
//         img: "Concerts/purim2019.jpg",
//         side_img: "Concerts/purim2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Purim20",
//         css_class: "unic-purim-2020",
//         id: "Purim_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Tel Aviv Fashion Week",
//         desc: "",
//         date: "03.20",
//         date2: "12.04.20",
//         img: "Concerts/fationWeek.jpg",
//         side_img: "Concerts/fationWeek.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=TelAviv_Fashion_Week.20",
//         css_class: "unic-fashion-week-2020",
//         id: "TelAviv_Fashion_Week_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jerusalem Marathon",
//         desc: "",
//         date: "20.03.20",
//         date2: "12.04.20",
//         img: "Concerts/jer-marathon.jpg",
//         side_img: "Concerts/jer-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=95",
//         css_class: "unic-singer-jer-maratho-2019",
//         id: "Jerusalem_Marathon",
//         book_now : "READ MORE"
//       },

//       // {
//       //   title: "The Rubinstein International Competition ",
//       //   desc: "",
//       //   date: "05-21.05.20",
//       //   date2: "21.05.20",
//       //   img:"Concerts/piano-competition-2020.jpg",
//       //   side_img:"Concerts/piano-competition-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Piano_Competition-2020",
//       //   css_class: "unic-singer-piano-competition-2020",
//       //   // id: "Piano_Competition-2020",
//       //   book_now : "READ MORE"
//       // },
//       // {
//       //   title: "Red Hot Chili Peppers",
//       //   desc: "",
//       //   date: "10.06.20",
//       //   date2: "10.06.20",
//       //   img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   side_img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Red_Hot_Chili_Peppers-2020",
//       //   css_class: "unic-singer-red-hot-chili-peppers-2020",
//       //   // id: "Red_Hot_Chili_Peppers-2020",
//       //   book_now : "READ MORE"
//       // },
//       // {
//       //   title: "Notte Bianca",
//       //   desc: "",
//       //   date: "06.20",
//       //   date2: "30.06.20",
//       //   img:"Concerts/53.jpg",
//       //   side_img:"Concerts/53.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=White_Night-2020",
//       //   css_class: "unic-singer-white-night-2020",
//       //   id: "White_Night_2020",
//       //   book_now : "READ MORE"
//       // },

// ];

// End showsArr

export const showsArr = [];

export const faqData = [
  {
    id: 1,
    q: "Frequently Asked Questions about the COVID-19",
    answer: `
      <ol start="1">
                          <li>
                            <strong>Sono un turista in Israele e sono preoccupato di avere contratto COVID-19, dove devo andare?</strong><br/>
                            Se dovessi avere la febbre a 38° o maggiore, tosse, problemi respiratori, o altri sintomi legati alla respirazione, <strong className="ac-pink">devi immediatamente entrare in auto isolamento e chiamare il 101 Servizio di Emergenza per un parere medico. Non andare in un pronto soccorso in ospedale.</strong>
                          </li>
                          <li>
                            <strong>Quando Israele verrà riaperta ai visitatori?</strong><br/>
                            Al momento non è possibile comunicare alcuna data di riapertura ai visitatori.
                          </li>
                         
                        </ol>
      `,
    isOpen: false,
  },
  {
    id: 2,
    q: "TEL AVIV E GERUSALEMME SONO LONTANE? ",
    answer: `
      <p>
       Al contrario! Sono molto più vicine di quello che pensi, con meno di 4 ore di volo puoi godere delle soleggiate spiagge di Tel Aviv e dei magnifici siti di Gerusalemme. E soprattutto, Tel Aviv e Gerusalemme sono distanti tra loro meno di un'ora di macchina.
      </p>
      `,
    isOpen: false,
  },

  {
    id: 3,
    q: "COME MUOVERSI A TEL AVIV E GERUSALEMME?",
    answer: `
      
      <p>
      Il miglior modo (e più conveniente) è il trasporto pubblico, bus, taxi collettivi e treni. Gerusalemme ha anche un comodissimo sistema tramviario tra i più popolari siti della città.</p><p> Per informazioni sulle fermate, linee ed orari, <a href="https://www.rail.co.il/en/" target="_blank" >www.rail.co.il.</a><br/>                                                                                                
      <p>Per informazioni riguardo linee ed orari bus visita <a href="https://www.bus.gov.il/?language=en#/origindestination/1/0" target="_blank" >www.bus.gov.il.</a> </p>                                                                                                                                        
      <p>Linea verde del traspoto pubblico <a href="tel:*8787">*8787</a>.  </p>                                                                                                                                                                                       
     <p> App del trasporto pubblico locale - Moovit. </p>                                                                                                                                                                               
      <h4>Taxi  </h4>                                                                                                                                                                                                                                                        
      <p>I taxi per corse urbane e interurbane possono essere fermati per strada o prenotati al telefono o con specifiche app come Gett (Get Taxi). </p>                        
      <h4>Taxi collettivi    </h4>                                                                                                                                                                                                                                      
       <p>Gli "Sherut" sono dei taxi collettivi da 10 o 12 posti a sedere che seguono generalemente le principali linee dei bus, all'interno e tra le principali città. I prezzi sono simili a quelli dei bus.  <br/>                                                                                                                                                                                               
       Car Rental La maggior parte delle agenzie di noleggio si trovano in Hayarkon Street, vicino il lungomare di Tel Aviv e nelle aree turistiche delle maggiori città, oltre che in aeroporto.   <br/>                                                                                                                                                                                                                  
       Tel-O-Fun Tel-O-Fun è un servizio di bike sharing per i locals e per i tutisti della città di Tel Aviv. Il servizio mette a disposizione in oltre 200 stazioni più di 2.000 biciclette utilizzabili negli oltre 130 km di piste ciclabili. E' possibile acquistare un abbonamento giornaliero o settimanale con la propria carta di credito direttamente presso ogni stazione.
      </p>
      .
      `,
    isOpen: false,
  },

  {
    id: 4,
    q: "RELATIVAMENTE AL DENARO?",
    answer: `
      <p>
        La moneta israeliana è lo Shekel. È possibile prelevare negli ATM in giro per le città. ATM privati sono anche disponibili nei chioschi dove vieene applicata una commissione di 5,90 - 7,90 Shekel per prelievo. Agenzie di cambio senza commissioni sono disponibili nelle aree turistiche e di solito aperte sino a tardi. Ovviamente le carte di credito sono largamente accettate. Western Union opera nella maggior parte degli uffici postali garantendo il servizio di trasferimento di denaro
      </p>
      `,
    isOpen: false,
  },

  {
    id: 5,
    q: "RESTARE CONNESSI",
    answer: `

        <p>
        Se vuoi, puoi acquistare una SIM card locale o delle carte prepagate nei negozi telefonici o nei punti informazione cittadini, in tanti piccoli stores o nelle agenzie di cambio.<br/> Hot spot - Free WIFI<br/>                                                                                          Tel Aviv ha il vanto di essere una smart city all'avanguardia. Il WIFI libero e gratuito è disponibile in 80 diverse zone della città (tra cui le spiagge, centri di intrattenimento e nelle maggiori aree turistiche).<br/>A Gerusalemme, le aree WIFI si trovano presso le stazioni del tram, università, musei, centri visitatori, convention centers, siti turistici, centri commerciali e Centri di Informazione Turistica
        </p>

      `,
    isOpen: false,
  },

  {
    id: 6,
    q: "COM'E' IL TEMPO? ",
    answer: `
        <p>
        Il tempo a Tel Aviv è caldo e gradevole praticamente tutto l'anno. L'estate è lunga e perfetta per stare in spiaggia o per muoversi in giro, l'inverno è mite con poche piogge. Le temperature medie invernali vanno dai 9° ai 17° C, mentre quelle medie estive oscillano tra i 24° e i 30°. Gerusalemme gode di lunghe e soleggiate estati (Maggio - Settembre) ed inverni (Novembre - Marzo) che possono anche essere molto freddi, piovosi e con occasionali nevicate che fanno crollare le temperature. Per informazioni in diretta visita il sito del Servizio Metereologico Israeliano: <a href="//ims.gov.il/en" traget="_blank" rel="noopener" >www.ims.gov.il</a>
        </p>
      `,
    isOpen: false,
  },

  {
    id: 7,
    q: "GLI ORARI DI LAVORO SONO DIVERSI?",
    answer: `
        
        <p>
          Si, le giornate lavorative vanno dalla Domenica al Giovedì mentre il weekend va dal Venerdì al Sabato. La maggior parte delle attività sono aperte il Venerdì sino al primo pomeriggio, prima del dell'inizio dello Shabbat Ebraico che dura dal tramonto del Venerdì sino a poco dopo il tramonto del Sabato.  www.timeanddate.com/worldclock/Israel
        </p>
      `,
    isOpen: false,
  },
];

export const newPosts = [
  //this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked
  {
    title: "Alla ricerca di una folle vita notturna?",
    // "sml_desc": "Prenota il tuo viaggio a Tel Aviv adesso!",
    sml_desc: "",
    // "desc": "",
    desc: "",
    img: "Videos/crazy-night.jpg",
    img_mob: "/Videos/video_mob/crazy-night.jpg",
    side_img: "Videos/sidebar/crazy-night.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=8",
    vidId: "ogEN7aRT0SM",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "Amazing_Nightlife",
  },
  // END this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked

  {
    title: "Gerusalemme",
    // "sml_desc": "Gerusalemme: il cuore del mondo",
    sml_desc: "",
    // "desc": "",
    desc: "",
    img: "Videos/heart-of-the-world.jpg",
    img_mob: "/Videos/video_mob/heart-of-the-world.jpg",
    side_img: "Videos/sidebar/heart-of-the-world.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Heart_Of_The_World",
    vidId: "nLKWDp5uA-U",
    ctg: "jerusalem",
    isVid: true,
    forVidPage: true,
    id: "Heart_Of_The_World",
  },

  {
    title: "MAGICA GIAFFA",
    sml_desc: "",
    // "sml_desc" : "GIAFFA: una città dal fascino multiculturale",
    desc: "",
    // "desc" : "Scopri tutte le ricchezze che la stupenda Giaffa antica può offrire",
    img: "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
    img_mob: "/PostCarousel/video_mob/joys-of-jaffa.jpg",
    side_img: "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=6",
    isVid: true,
    forVidPage: true,
    vidId: "xz05_8hA4q4",
    ctg: "telaviv",
    id: "Joys_Of_Jaffa",
  },
  {
    title: "Il Mar Morto",
    // "sml_desc": "È giunto il momento di rilassarsi nella natura",
    sml_desc: "",
    desc: "",
    // "desc": "Goditi la vita nel luogo più basso della Terra",
    img: "/PostCarousel/DeadSea/natural-spa.jpg",
    img_mob: "/PostCarousel/video_mob/natural-spa.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=2",
    isVid: true,
    forVidPage: true,
    vidId: "Kmq8NulV8Mo",
    ctg: "deadsea",
    id: "Dead_Sea2",
  },
  {
    title: "TEL AVIV SUL MARE",
    // "sml_desc": "Perché a Tel Aviv la vita è una spiaggia ",
    sml_desc: "",
    // "desc": "Preparati a divertirti alla grande sotto il sole",
    desc: "",
    img: "Videos/a.jpg",
    img_mob: "/Videos/video_mob/a.jpg",
    side_img: "Videos/sidebar/a.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=3",
    css_class: "unic_video-post-4",
    vidId: "BEmvshdB1ao",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "TelAviv_By_The_Sea",
  },

  {
    title: "Sarona Tel Aviv",
    desc: "",
    // "desc": "Un’enorme scelta di attrazioni in  una colonia templare incredibilmente rinnovata",
    // "sml_desc": "Un’incredibile oasi urbana",
    sml_desc: "",
    img: "Videos/d.jpg",
    img_mob: "/Videos/video_mob/d.jpg",
    side_img: "Videos/sidebar/d.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=1",
    vidId: "XFgR0acFwF4",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "Sarona_TelAviv",
  },
  {
    title: "I piaceri del porto",
    // "sml_desc": "I diversi fascini dei <br>porti di Tel Aviv e di Jaffa ",
    sml_desc: "",
    // "desc": "I piaceri del porto",
    desc: "",
    img: "/PostCarousel/TelAviv/3.jpg",
    img_mob: "/PostCarousel/video_mob/3.jpg",
    side_img: "/PostCarousel/TelAviv/3.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Port_Pleasures",
    isVid: true,
    forVidPage: true,
    vidId: "xz05_8hA4q4",
    ctg: "telaviv",
    id: "Port_Pleasures",
  },

  {
    title: "Neve Tzedek",
    sml_desc: "",
    // "sml_desc" : "Chic ed esclusiva",
    // "desc": "Ricca di bellissimi caffè, boutique, gallerie d’arte, eleganza e vitalità",
    desc: "",
    img: "Videos/j.jpg",
    img_mob: "/Videos/video_mob/j.jpg",
    side_img: "Videos/sidebar/j.jpg",
    read_more: "READ MORE",
    vidId: "R0QsWBZfIpU",
    link: "/Posts/index.php?postType=video&post=7",
    css_class: "unic_video-post-13",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "Neve_Tzedek",
  },

  {
    title: "Gerusalemme vecchia e nuova",
    // "sml_desc": "Tesori antichi e lusso moderno",
    sml_desc: "",
    desc: "",
    // "desc": "Un’entusiasmante avventura a Gerusalemme, una città incredibile",
    img: "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    img_mob: "/PostCarousel/video_mob/jerusalem-old-city.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=8",
    css_class: "old-new-jer",
    isVid: true,
    forVidPage: true,
    vidId: "3g9T1HMP39Q",
    ctg: "jerusalem",
    id: "New_And_OLd_Jerusalem",
  },

  {
    title: "Mercato di Machne Yehuda",
    // "sml_desc": "Una festa dei sensi",
    sml_desc: "",
    // "desc": "Non lasciarti sfuggire le vedute, i suoni,  gli odori e, naturalmente, i gusti di questo mercato",
    desc: "",
    img: "Videos/market-madness.jpg",
    img_mob: "/Videos/video_mob/market-madness.jpg",
    side_img: "Videos/sidebar/market-madness.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=7",
    vidId: "2CSCe2WC7Ns",
    ctg: "culinary",
    isVid: true,
    forVidPage: true,
    id: "Market_Madness",
  },

  {
    title: "La città vecchia",
    sml_desc: "",
    // "sml_desc": "Senti la storia che prende vita",
    desc: "",
    // "desc": "Fatti ispirare dai famosi tesori dell’antica città di Gerusalemme",
    img: "Videos/m.jpg",
    img_mob: "/Videos/video_mob/m.jpg",
    side_img: "Videos/sidebar/m.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=4",
    isVid: true,
    forVidPage: true,
    vidId: "RwzdqkM3_CU",
    ctg: "jerusalem",
    id: "Jerusalem_Old_City",
  },

  {
    title: "Tel Aviv su due ruote",
    // "sml_desc" : "Avventure all’aperto",
    sml_desc: "",
    desc: "Una città ricca di azione – perfetta per persone attive",
    side_img: "PostCarousel/TelAviv/tlv-on-wheels.jpg",
    img_mob: "/PostCarousel/video_mob/tlv-on-wheels.jpg",
    img: "PostCarousel/TelAviv/tlv-on-wheels.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "page-telaviv-adventures",
    ctg: "telaviv",
    vidId: "-eNQe5STaGY",
    isVid: true,
    forVidPage: true,
    id: "TelAviv_On_Wheels",
  },

  {
    title: "Il Mar Morto ",
    // "sml_desc": "È giunto il momento di rilassarsi nella natura",
    sml_desc: "",
    // "desc": "Goditi la vita nel luogo più basso della Terra  ",
    desc: "",
    img: "/PostCarousel/DeadSea/natures-glory.jpg",
    img_mob: "/PostCarousel/video_mob/natures-glory.jpg",
    side_img: "/PostCarousel/DeadSea/natures-glory.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Dead_Sea_Video",
    isVid: true,
    forVidPage: true,
    ctg: "deadsea2",
    vidId: "ixFocykfYHo",
    id: "Dead_Sea_Video",
  },

  {
    title: "2  fantastiche città",
    // "sml_desc": "Una magica e indimenticabile fuga verso il sole",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    side_img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=42",
    isVid: false,
    forVidPage: true,
    ctg: "telavivAndJerusalem",
    id: "2_AWESOME_CITIES",
  },

  {
    title: "Divertimento nonstop",
    // "sml_desc": "Bellissima, colorata ed eccitante – Fantastica Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    side_img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nonstop_Excitement",
    ctg: "telaviv",
    isVid: false,
    forVidPage: true,
    id: "Nonstop_Excitement",
  },
  {
    title: "Gerusalemme ti chiama",
    // "sml_desc": "La città più magica<br> e splendida sulla Terra",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/4.jpg",
    side_img: "/PostCarousel/4.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=4",
    ctg: "jerusalem",
    isVid: false,
    forVidPage: true,
    id: "Jerusalem_Calling",
  },

  {
    title: "SCOPRI MASADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/masada.jpg",
    side_img: "/PostCarousel/DeadSea/masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Masada",
    isVid: false,
    forVidPage: true,
    ctg: "deadsea",
    id: "Masada",
  },

  {
    title: "Una meta per lo shopping",
    // "sml_desc": "Dalla moda ai souvenir, Gerusalemme ha tutto",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/5.jpg",
    side_img: "/PostCarousel/5.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Shopping_Delights",
    ctg: "jerusalem",
    isVid: false,
    forVidPage: true,
    id: "Shopping_Delights",
  },

  {
    title: "Incredibile vita notturna",
    sml_desc: "",
    // "sml_desc": "Incredibile vita notturna",
    desc: "",
    // "desc": "Una festa senza fine nella<br> città che non si ferma mai!",
    img: "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    side_img: "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Amazing_Nightlife",
    isVid: false,
    forVidPage: true,
    ctg: "telaviv",
    id: "Amazing_Nightlife",
  },

  {
    title: "I must di Gerusalemme",
    // "sml_desc": "Le 5 cose da fare e vedere<br> in questa incantevole città",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/18.jpg",
    side_img: "/PostCarousel/18.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_Musts",
    isVid: false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem_Musts",
  },

  {
    title: "LUOGHI IMPORTANTI DI GERUSALEMME",
    sml_desc: "",
    // "desc": "Lo spirito di Gerusalemme",
    desc: "",
    img: "PostCarousel/Jerusalem/main-sites-jer.jpg",
    side_img: "PostCarousel/Jerusalem/main-sites-jer.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=9",
    ctg: "jerusalem",
    css_class: "page-jerusalem-mainsites",
    isVid: false,
    forVidPage: true,
    id: "Jerusalem_Main_Sites",
  },

  {
    title: "Spazio alla cultura",
    // "sml_desc": "Spazio alla cultura",
    sml_desc: "",
    // "desc": "Una grande varietà di affascinanti musei e gallerie uniche",
    desc: "",
    img: "/PostCarousel/TelAviv/culture-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/culture-telaviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Non_Stop_Culture",
    isVid: false,
    forVidPage: false,
    ctg: "telaviv",
    id: "Non_Stop_Culture",
  },
  {
    title: "Spiagge sensazionali",
    // "sml_desc": "Vieni a rilassarti sulle assolate spiagge di Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/sensational-beaches2.jpg",
    side_img: "/PostCarousel/TelAviv/sensational-beaches2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=14",
    isVid: false,
    forVidPage: true,
    ctg: "telaviv",
    //"id": 14
    id: "Sensational_Beaches",
  },

  {
    title: "I must di Tel Aviv",
    sml_desc: "",
    desc: "Le 5 cose da fare e vedere in città",
    img: "/PostCarousel/17.jpg",
    side_img: "/PostCarousel/17.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=17",
    ctg: "telaviv",
    css_class: "page-telaviv-highlights",
    isVid: false,
    forVidPage: true,
    id: "TelAviv_Highlights",
  },

  {
    title: "Moderna e vivace",
    // "sml_desc": "C’è tanto da vedere nel<br> vivace centro di Gerusalemme",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/19.jpg",
    side_img: "/PostCarousel/19.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Modern_And_Vibrant",
    isVid: false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Modern_And_Vibrant",
  },

  {
    title: "Jamie Olivier si gode il gusto della tipica colazione di Tel Aviv",
    // "sml_desc": "Jamie Olivier si gode il gusto della tipica colazione di Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "Videos/jamie-oliver.jpg",
    img_mob: "/Videos/video_mob/jamie-oliver.jpg",
    side_img: "Videos/sidebar/jamie-oliver.jpg",
    vidId: "gGe4W8WaIiQ",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jamie_Oliver",
    ctg: "culinarytelaviv",
    isVid: true,
    forVidPage: true,
    id: "Jamie_Oliver",
  },

  {
    title: "L'atmosfera vegana di Tel Aviv",
    sml_desc: "Votata come migliore <br> destinazione vegana del mondo",
    desc:
      "Approfitta dell’enorme scelta di prelibatezze vegane, tra cui il gelato vegano!",
    side_img: "PostCarousel/TelAviv/vegan-scene-tlv.jpg",
    img_mob: "/Videos/video_mob/h.jpg",
    img: "PostCarousel/TelAviv/vegan-scene-tlv.jpg",
    vidId: "SP0kGcLSVQk",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=6",
    ctg: "culinarytelaviv",
    css_class: "page-telaviv-vegan",
    isVid: true,
    forVidPage: true,
    id: "TLV_Vegan_Scene",
  },
  {
    title: "LA CUCINA A TEL AVIV",
    // "sml_desc": "Destinazione culinaria... da lasciare a bocca aperta",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/la-cucina.jpg",
    side_img: "/PostCarousel/la-cucina.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=12",
    ctg: "culinarytelaviv",
    isVid: true,
    forVidPage: true,
    vidId: "jfyHxk8ZRrI",
    id: "La_Cucina_A_TelAviv",
  },
  {
    // "title": "A Foodie’s Paradise‘",
    title: "Tel Aviv – Semplicemente deliziosa",
    // "sml_desc": "Il paradiso dei buongustai",
    sml_desc: "",
    // "desc": "Centinaia di buonissimi ristoranti, <br> stupendi mercati e cibo di strada eccezionale",
    desc: "",
    img: "/PostCarousel/99.jpg",
    img_mob: "/PostCarousel/video_mob/99.jpg",
    side_img: "/PostCarousel/99.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=21",
    ctg: "culinarytelaviv",
    vidId: "n4kCnPXEX7g",
    isVid: true,
    forVidPage: true,
    id: "Simply_Delicious",
  },
  {
    title: "La cucina di Gerusalemme",
    sml_desc: "",
    // "desc": "Esaltante e varia…deliziosa!",
    desc: "",
    img: "PostCarousel/Culinary/cuisine-jer.jpg",
    img_mob: "/PostCarousel/video_mob/cuisine-jer.jpg",
    side_img: "PostCarousel/Culinary/cuisine-jer.jpg",
    read_more: "READ MORE",
    vidId: "2CSCe2WC7Ns",
    link: "/Posts/index.php?post=13",
    ctg: "culinaryjerusalem",
    isVid: true,
    forVidPage: true,
    id: "Jerusalem_Cuisine",
  },

  {
    title: "Cosa mangiare a Gerusalemme",
    // "sml_desc": "Must eat dishes to try when visiting the magical city",
    desc: "",
    sml_desc: "",
    img: "/PostCarousel/37.jpg",
    img_mob: "/PostCarousel/video_mob/37.jpg",
    side_img: "/PostCarousel/37.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=38",
    ctg: "culinaryjerusalem",
    vidId: "2CSCe2WC7Ns",
    isVid: true,
    forVidPage: true,
    id: "A_Taste_Of_Jerusalem",
  },

  {
    title: "È l’ora della Shakshuka",
    sml_desc: "",
    // "desc": "Impara a cucinare la famosa Shakshuka!",
    desc: "",
    img: "PostCarousel/Culinary/shakshuka-time.jpg",
    img_mob: "/Videos/video_mob/shakshuka-time.jpg",
    side_img: "PostCarousel/Culinary/shakshuka-time.jpg",
    read_more: "READ MORE",
    vidId: "JjxXlP-Zk7M",
    link: "/Posts/index.php?post=22",
    ctg: "culinary",
    isVid: true,
    forVidPage: true,
    id: "Shakshuka_Time",
  },

  {
    title: "Il panorama culinario di Tel Aviv",
    // "sml_desc" : "Risvegliate le vostre papille gustative a Tel Aviv",
    sml_desc: "",
    desc: "",
    // "desc" : "Un gran numero di incredibili ristoranti - Il luogo perfetto per trattarvi bene",
    img: "Videos/e.jpg",
    img_mob: "/Videos/video_mob/e.jpg",
    side_img: "Videos/sidebar/e.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=33",
    ctg: "culinary",
    vidId: "jfyHxk8ZRrI",
    css_class: "unic_video-post-11",
    isVid: true,
    forVidPage: true,
    id: "TLV_Gourmet_Scene",
  },

  {
    title: "CAFFÈ IN TEL AVIV",
    // "sml_desc": "Tel Aviv over a fresh coffee",
    sml_desc: "",
    // "desc": "Coffee shop culture is fundamental",
    desc: " ",
    img: "Videos/coffee.jpg",
    img_mob: "/Videos/video_mob/coffee.jpg",
    side_img: "Videos/sidebar/coffee.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=16",
    vidId: "rVr0gqFC364",
    ctg: "culinarytelaviv",
    isVid: true,
    forVidPage: true,
    id: "Coffee_In_TelAviv",
  },
  {
    title: "MAR MORTO",
    sml_desc: "",
    // "sml_desc": "THE DEAD SEA",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-spa2.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natural_Spa",
    isVid: false,
    forVidPage: true,
    ctg: "deadsea",
    id: "Natural_Spa2",
  },

  {
    title: "Viaggiare con i bambini",
    // "sml_desc": "Divertimento non stop per tutta la famiglia ",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/33.jpg",
    side_img: "/PostCarousel/33.jpg",
    read_more: "Weiterlesen",
    link: "/Posts/index.php?post=25",
    isVid: false,
    ctg: "telavivAndJerusalem",
    id: 41,
  },

  {
    title: "Cosa fare di bello a Tel Aviv",
    // "sml_desc": "Cool things to do in the hot city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/40.jpg",
    side_img: "/PostCarousel/40.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=TelAviv_Adventures",
    ctg: "telaviv",
    isVid: false,
    id: "TelAviv_Adventures",
  },

  {
    title: "Girare in bici a Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "PostCarousel/39.jpg",
    side_img: "PostCarousel/39.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=31",
    ctg: "telaviv",
    css_class: "page-telaviv-cycle",
    isVid: false,
    forVidPage: true,
    id: "Cycle_TelAviv",
  },

  {
    title: "Le sorprese di Gerusalemme",
    // "sml_desc": "Una città che supera le aspettative",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/38.jpg",
    side_img: "/PostCarousel/38.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Cool_Jerusalem",
    ctg: "jerusalem",
    isVid: false,
    forVidPage: true,
    id: "Cool_Jerusalem",
  },

  {
    title: "La destinazione di lusso che non ti aspetti",
    sml_desc: "",
    desc: "Tel Aviv - The ultimate luxury destination",
    img: "/PostCarousel/36.jpg",
    side_img: "/PostCarousel/36.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=28",
    ctg: "telaviv",
    css_class: "page-telaviv-enjoy",
    isVid: false,
    id: "Enjoy_And_Indulge",
  },

  {
    title: "Una giornata a Tel Aviv",
    sml_desc: "",
    // "sml_desc" : "Da un porto all’altro",
    desc: "",
    // "desc" : "Da un porto all’altro",
    img: "/PostCarousel/TelAviv/day-is-trippin.jpg",
    side_img: "/PostCarousel/TelAviv/day-is-trippin.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Day_IsTrippin",
    isVid: false,
    ctg: "telaviv",
    id: "Day_IsTrippin",
  },

  {
    title: "Gerusalemme e Tel Aviv",
    // "sml_desc": "A meno di un’ora di distanza!",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/34.jpg",
    side_img: "/PostCarousel/34.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=35",
    ctg: "telaviv",
    isVid: false,
    // "id": 35
    id: "Go_To_Guide",
  },
  {
    title: "Una città magica di splendore",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/6.jpg",
    side_img: "/PostCarousel/Jerusalem/6.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Magic_City_Of_Splender",
    isVid: false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Magic_City_Of_Splender",
  },
  {
    title: "TEL AVIV TRA LE 50 DESTINAZIONI DA VISITARE NEL 2018",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/destinations.jpg",
    side_img: "/PostCarousel/TelAviv/destinations.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=50_Destinations_To_Visit",
    isVid: false,
    ctg: "telaviv",
    id: "50_Destinations_To_Visit",
  },

  {
    title: "Le gioie del Mar Morto",
    // "sml_desc": "Per un buon tempo fluttuante",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/deadsea1.jpg",
    side_img: "/PostCarousel/DeadSea/deadsea1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Next_Level_DS",
    isVid: false,
    ctg: "deadsea",
    id: "Dead_Sea1",
  },
  {
    title: "VIALE MAMILLA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    side_img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Mamilla_Avenue",
    isVid: false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Mamilla_Avenue",
  },
  {
    title: "LE PORTE DI GERUSALEMME",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/gates.jpg",
    side_img: "/PostCarousel/Jerusalem/gates.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Gates_Of_Jerusalem",
    isVid: false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "The_Gates_Of_Jerusalem",
  },
  {
    title: "IL MAR MORTO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/magical-deadsea2.jpg",
    side_img: "/PostCarousel/DeadSea/magical-deadsea2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Magical_Deadsea",
    isVid: false,
    forVidPage: true,
    ctg: "deadsea",
    id: "Magical_Deadsea",
  },
  {
    title: "ACQUISTI ESCLUSIVI IN ISRAELE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/unique.jpg",
    side_img: "/PostCarousel/Jerusalem/unique.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Purchases_In_Israel",
    isVid: false,
    ctg: "jerusalem",
    id: "Purchases_In_Israel",
  },

  // IT posts only
  {
    title: "50 BEST DISCOVERY",
    // "sml_desc": "",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/50best-discovery.jpg",
    side_img: "/PostCarousel/it/50best-discovery.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=76",
    isVid: false,
    css_class: "50best-discovery-css-it",
    ctg: "telaviv",
    id: "50_Best_Discovery_It",
  },
  {
    title: "DESTINAZIONE TOP PER IL 2020",
    // "sml_desc": "Top 20 destinazioni del 2020 secondo Forbes.com",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/forbes.jpg",
    side_img: "/PostCarousel/it/forbes.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=77",
    isVid: false,
    css_class: "forbes-css-it",
    ctg: "telaviv",
    id: "Forbes_It",
  },

  {
    title: "2000 year old wine and fish",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/2000yearold.jpg",
    side_img: "/PostCarousel/it/2000yearold.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=78",
    isVid: false,
    css_class: "2000-year-old-wine-and-fish-css-it",
    ctg: "telaviv",
    id: "2000_Year_Old_Wine_And_Fish_It",
  },

  // This posts Hadar asked not to show inside the carousel, but to show just link to the inner post.
  // {
  //     "title": "MAR MORTO",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/.jpg",
  //     "side_img": "/PostCarousel/.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=80",
  //     "isVid": false,
  //     "css_class": "mar-morto-it-css-it",
  //     "ctg": "deadsea",
  //     "id": "Mar_Morto_It"
  // },
  // {
  //     "title": "Cesarea, storia millenaria e acque cristalline",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/.jpg",
  //     "side_img": "/PostCarousel/.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=81",
  //     "isVid": false,
  //     "css_class": "cesarea2-css-it",
  //     "ctg": "nortrh",
  //     "id": "Cesarea2_It"
  // },

  // {
  //     "title": "TU BISHVAT",
  //    // "sml_desc": "IL CAPODANNO DEGLI ALBERI",
  //     "desc": "",
  //     "img": "/PostCarousel/tubishvat2020.jpg",
  //     "side_img": "/PostCarousel/tubishvat2020.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=82",
  //     "isVid": false,
  //     "css_class": "cesarea2-css-it",
  //     "ctg": "jerusalem",
  //     "id": "Tu_Bishvat_It"
  // },
  // {
  //     "title": "DAROM ADOM",
  //     "sml_desc": "la magia del deserto in fiore",
  //     "desc": "",
  //     "img": "/PostCarousel/daromadom.jpg",
  //     "side_img": "/PostCarousel/daromadom.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=83",
  //     "isVid": false,
  //     "css_class": "cesarea2-css-it",
  //     "ctg": "eilat",
  //     "id": "Darom_Adom_It"
  // },

  //TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES from HADAR
  // {
  //     "title": "Chanukkah",
  //     // "sml_desc": "",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/chanukkah.jpg",
  //     "side_img": "/PostCarousel/chanukkah.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=70",
  //     "isVid": false,
  //     "css_class": "chanukkah-css-it",
  //     "ctg": "jerusalem",
  //     "id": "Chanukkah_It"
  // },

  // {
  //     "title": "Run the City",
  //     // "sml_desc": "Tel Aviv si scopre correndo",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/run-the-city.jpg",
  //     "side_img": "/PostCarousel/run-the-city.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=71",
  //     "isVid": false,
  //     "css_class": "run-the-city-css-it",
  //     "ctg": "telaviv",
  //     "id": "Run_The_City_It"
  // },
  //END TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES from HADAR

  //HADAR ASKED TO DELETE THIS POST THE CORRECTIONS FROM LISHKA THAT SHE SENT
  // {
  //     "title": "Tel Aviv Museum",
  //     // "sml_desc": "Due importanti mostre al<br> Tel Aviv Museum of Art",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/museotel-aviv.jpg",
  //     "side_img": "/PostCarousel/museotel-aviv.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=72",
  //     "isVid": false,
  //     "css_class": "tlv-museum-css-it",
  //     "ctg": "telaviv",
  //     "id": "Tel_Aviv_Museum_It"
  // },
  //end HADAR ASKED TO DELETE THIS POST THE CORRECTIONS FROM LISHKA THAT SHE SENT
  {
    title: "Timna Park",
    // "sml_desc": "Avventura tra le rocce del Timna Park",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/timna-park.jpg",
    side_img: "/PostCarousel/it/timna-park.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=73",
    isVid: false,
    css_class: "timna-park-css-it",
    ctg: "eilat",
    id: "Timna_Park_It",
  },
  //ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA
  // {
  //     "title": "A ritmo di musica",
  //     // "sml_desc": "Gerusalemme a ritmo di musica con <br>la Jerusalem International Dance Week",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/dance-week.jpg",
  //     "side_img": "/PostCarousel/dance-week.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=74",
  //     "isVid": false,
  //     "css_class": "ritmo-di-musica-css-it",
  //     "ctg": "jerusalem",
  //     "id": "A_Ritmo_Di_Musica_It"
  // },
  //end ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA

  //ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA
  // {
  //     "title": "Il Mar di Galilea",
  //     // "sml_desc": "Una maratona lungo il Mar di Galilea<br/> per dare il benvenuto al 2020",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/kineret.jpg",
  //     "side_img": "/PostCarousel/kineret.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=75",
  //     "isVid": false,
  //     "css_class": "il-mar-di-galilea-css-it",
  //     "ctg": "north",
  //     "id": "Il_Mar_Di_Galilea_It"
  // },
  //eND ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA
  {
    title: "Israeli innovation peres center",
    // "sml_desc": "L’Israeli Innovation Center di Tel Aviv mette in mostra la Start-Up Nation",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/Israeli_innovation_peres_center.jpg",
    side_img: "/PostCarousel/it/Israeli_innovation_peres_center.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=66",
    isVid: false,
    css_class: "israeli-innovation-it",
    ctg: "telaviv",
    id: "Israeli_Innovation_It",
  },
  //ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA
  // {
  //     "title": "Le maratone",
  //     // "sml_desc": "Israele…di corsa! Le maratone in programma da novembre 2019 a dicembre 2020",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/Le_maratone.jpg",
  //     "side_img": "/PostCarousel/Le_maratone.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=67",
  //     "isVid": false,
  //     "css_class": "le-maratone-css-it",
  //     "ctg": "telaviv",
  //     "id": "Le_Maratone_It"
  // },

  // {
  //     "title": "Inverno a Eilat",
  //     // "sml_desc": "Inverno a Eilat",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/Inverno_a_Eilat.jpg",
  //     "side_img": "/PostCarousel/Inverno_a_Eilat.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=68",
  //     "isVid": false,
  //     "css_class": "inverno-a-eilat-css-it",
  //     "ctg": "eilat",
  //     "id": "Inverno_A_Eilat_It"
  // },
  //eND ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA
  {
    title: "TLV Time Out",
    // "sml_desc": "Tel Aviv entra due volte nella classifica di Time Out sui 50 quartieri più belli al mondo",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/TLV_Time_Out.jpg",
    side_img: "/PostCarousel/it/TLV_Time_Out.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=69",
    isVid: false,
    css_class: "tlv-time-out-css-it",
    ctg: "telaviv",
    id: "TLV_Time_Out_It",
  },
  // TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES FROM HADAR CORRECTIONS LISHKA
  // {
  //     "title": "DLD Innovation Festival",
  //     // "sml_desc": "l’innovazione è di casa a Tel Aviv",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/it-dvd-innovation.jpg",
  //     "side_img": "/PostCarousel/it-dvd-innovation.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=60",
  //     "isVid": false,
  //     "css_class": "it-dvd-innovation-css",
  //     "ctg": "telaviv",
  //     "id": "DLD_Innovation_Festival_It"
  // },

  // {
  //     "title": "Mekudeshet Festival",
  //     // "sml_desc": "Un mix di culture e arti per il nuovo Mekudeshet Festival",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/it-Mekudeshet-JLM.jpg",
  //     "side_img": "/PostCarousel/it-Mekudeshet-JLM.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=61",
  //     "isVid": false,
  //     "css_class": "it-Mekudeshet-jlm-css",
  //     "ctg": "jerusalem",
  //     "id": "Mekudeshet_Festival_It"
  // },

  // {
  //     "title": "Open House Tel Aviv",
  //     // "sml_desc": "Alla scoperta degli edifici<br> più iconici di Tel Aviv",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/it-open-house-tlv.jpg",
  //     "side_img": "/PostCarousel/it-open-house-tlv.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=62",
  //     "isVid": false,
  //     "css_class": "it-open-house-tlv-css",
  //     "ctg": "telaviv",
  //     "id": "Open_House_Tel_Aviv_It"
  // },

  // {
  //     "title": "Alture del Golan",
  //     // "sml_desc": "Alla scoperta delle Alture del Golan tra natura, archeologia e del buon vino",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/it-ramat-ha-golan.jpg",
  //     "side_img": "/PostCarousel/it-ramat-ha-golan.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=63",
  //     "isVid": false,
  //     "css_class": "it-ramat-ha-golan-css",
  //     "ctg": "north",
  //     "id": "Alture_del_Golan_It"
  // },

  // {
  //     "title": "Rosh haShana",
  //     // "sml_desc": "Rosh haShana, il Capodanno ebraico",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/it-rosh-hashana.jpg",
  //     "side_img": "/PostCarousel/it-rosh-hashana.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=64",
  //     "isVid": false,
  //     "css_class": "it-rosh-hashana-css",
  //     "ctg": "jerusalem",
  //     "id": "Rosh_HaShana_It"
  // },

  // {
  //     "title": "Solar Guerrilla Exhibition",
  //     // "sml_desc": "Con la Solar Guerrilla Exhibition il TAM di Tel Aviv affronta il cambiamento climatico",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/it-solar-guerrilla-exhibit.jpg",
  //     "side_img": "/PostCarousel/it-solar-guerrilla-exhibit.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=65",
  //     "isVid": false,
  //     "css_class": "it-solar-guerrilla-exhibit-it-css",
  //     "ctg": "telaviv",
  //     "id": "Solar_Guerrilla_Exhibition_It"
  // },
  // end TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES FROM HADAR CORRECTIONS LISHKA
  {
    title: "Avventure in Israele",
    // "sml_desc": "per una vacanza all’insegna dello sport",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/Avventure_in_Israele.jpg",
    side_img: "/PostCarousel/it/Avventure_in_Israele.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=53",
    isVid: false,
    css_class: "avventure-in-israele-css-it",
    ctg: "eilat",
    id: "Avventure_In_Israele_It",
  },
  {
    title: "Grandi concerti a Tel Aviv",
    // "sml_desc": "A Tel Aviv un’estate all’insegna della grande musica internazionale",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/Grandi_concerti_a_TelAviv.jpg",
    side_img: "/PostCarousel/it/Grandi_concerti_a_TelAviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=54",
    isVid: false,
    css_class: "grandi-concerti-it-css",
    ctg: "telaviv",
    id: "Grandi_Concerti_It",
  },
  {
    title: "International arts & crafts fair",
    // "sml_desc": "Gerusalemme alla scoperta dell’artigianato con l’International arts and crafts fair",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/international_arts_&_crafts_fair.jpg",
    side_img: "/PostCarousel/it/international_arts_&_crafts_fair.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=55",
    isVid: false,
    css_class: "internation-arts-css-it",
    ctg: "jerusalem",
    id: "International_Arts_It",
  },
  {
    title: "Jerusalem Film Festival",
    // "sml_desc": "Il grande cinema arriva in Israele con il Jerusalem Film FEstival",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/Jerusalem_Film_Festival.jpg",
    side_img: "/PostCarousel/it/Jerusalem_Film_Festival.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=56",
    isVid: false,
    css_class: "jerusalem-film-festival",
    ctg: "jerusalem",
    id: "Jerusalem_Film_Festival_It",
  },
  {
    title: "Mostre estive in Israele",
    // "sml_desc": "Mostre estive in Israele",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/Mostre_estive_in_Israele.jpg",
    side_img: "/PostCarousel/it/Mostre_estive_in_Israele.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=57",
    isVid: false,
    css_class: "mostre-estive-in-israele-it-css",
    ctg: "telaviv",
    id: "Mostre_Estive_In_Israele_It",
  },
  {
    title: "Red Sea Jazz Festival",
    // "sml_desc": "Il jazz invade Eilat: nuova edizione per il Red Sea Jazz Festival",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/Red_Sea_Jazz_Festival.jpg",
    side_img: "/PostCarousel/it/Red_Sea_Jazz_Festival.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=58",
    isVid: false,
    css_class: "red-sea-jazz-festival-it-css",
    ctg: "eilat",
    id: "Red_Sea_Jazz_Festival_It",
  },
  {
    title: "Tisha b'av",
    // "sml_desc": "Tisha b’Av, il popolo ebraico si ferma",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/Tisha_bav.jpg",
    side_img: "/PostCarousel/it/Tisha_bav.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=59",
    isVid: false,
    css_class: "tisha-bav-it-css",
    ctg: "jerusalem",
    id: "Tisha_Beav_It",
  },
  {
    title: "JERUSALEM FESTIVAL OF LIGHTS",
    // "sml_desc": "",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/jerusalem_festival_of_lights.jpg",
    side_img: "/PostCarousel/it/jerusalem_festival_of_lights.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=48",
    isVid: false,
    css_class: "festival-of-lights-it-css",
    ctg: "jerusalem",
    id: "Festival_Of_Lights_It",
  },

  //HAdar asked to hide
  // {
  //     "title": "è Israele il vero vincitore!",
  //     // "sml_desc": "",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/post_eurovision.jpg",
  //     "side_img": "/PostCarousel/post_eurovision.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=49",
  //     "isVid": false,
  //     "css_class": "post-eurovision-it-css",
  //     "ctg": "telaviv",
  //     "id": "Eurovision_2019_It"
  // },
  {
    title: "Jerusalem Design Week",
    // "sml_desc": "A giugno una nuova edizione della Jerusalem Design Week",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/jerusalem_design_week.jpg",
    side_img: "/PostCarousel/it/jerusalem_design_week.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=50",
    isVid: false,
    css_class: "jerusalem-design-week-it-css",
    ctg: "jerusalem",
    id: "Jerusalem_Design_Week_It",
  },
  {
    title: "Wine Festival",
    // "sml_desc": "Con Wine&Plenty alla scoperta dei vini israeliani",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/wine_festival.jpg",
    side_img: "/PostCarousel/it/wine_festival.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=51",
    isVid: false,
    css_class: "wine-festival-it-css",
    ctg: "telaviv",
    id: "Wine_Festival_It",
  },
  {
    title: "Zichron Ya’akov",
    // "sml_desc": "Zichron Ya’akov, alla scoperta della città tra vino e natura",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/zichron_yaakov.jpg",
    side_img: "/PostCarousel/zichron_yaakov.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=52",
    isVid: false,
    css_class: "zichron_yaakov-it-css",
    ctg: "north",
    id: "Zichron_Yakov_It",
  },
  {
    title: "Cesarea",
    // "sml_desc": "Alla scoperta di Cesarea, storia millenaria e acque cristalline",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/cesarea.jpg",
    side_img: "/PostCarousel/cesarea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=42",
    isVid: false,
    css_class: "cesarea-css-it",
    ctg: "north",
    id: "Cesarea_It",
  },
  // {
  //     "title": "Tel Aviv Eurovision",
  //     // "sml_desc": "TUTTO PRONTO PER L’EUROVISION A TEL AVIV",
  //     "sml_desc": "",
  //     "desc": "",
  //     // "desc": "Al via il 14 maggio l’edizione 2019 del celebre festival musicale europeo: città in festa e pronta al grande evento",
  //     "img": "/PostCarousel/eurovision.jpg",
  //     "side_img": "/PostCarousel/eurovision.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=43",
  //     "isVid": false,
  //     "css_class": "tel-aviv-eurovision-css",
  //     "ctg": "telaviv",
  //     "id": "Tel_Aviv_Eurovision_It"
  // },
  {
    title: "Gay Pride",
    // "sml_desc": "Non solo Eurovision",
    sml_desc: "",
    // "desc": "il Gay Pride animerà l’estate di Tel Aviv",
    desc: "",
    img: "/PostCarousel/it/pride.jpg",
    side_img: "/PostCarousel/it/pride.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=44",
    isVid: false,
    css_class: "gay-pride-it-css",
    ctg: "telaviv",
    id: "Gay_Pride_It",
  },
  {
    title: "Informazioni turistiche",
    // "sml_desc": "Tutto quello che devi sapere",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/TI.jpg",
    side_img: "/PostCarousel/it/TI.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=41",
    isVid: false,
    css_class: "tourist-info-it-css",
    ctg: "telaviv",
    id: "Tourist_Info_It",
  },
  {
    title: "Mountain2Valley",
    // "sml_desc": "Torna la Mountain2Valley",
    sml_desc: "",
    // "desc": "la più importante corsa a staffetta di Israele",
    desc: "",
    img: "/PostCarousel/it/mountain2Valley.jpg",
    side_img: "/PostCarousel/it/mountain2Valley.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=45",
    isVid: false,
    css_class: "mountain2Valley-css",
    ctg: "telaviv",
    id: "Mountain2Valley_It",
  },
  {
    title: "Writers Festival",
    // "sml_desc": "L’International Writers Festival arriva a Gerusalemme dal 12 al 16 maggio 2019",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/writersfestival.jpg",
    side_img: "/PostCarousel/it/writersfestival.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=46",
    isVid: false,
    css_class: "writersfestival-css",
    ctg: "telaviv",
    id: "Writers_Festival_It",
  },
  {
    title: "Yom HaZikaron e HaAtzmaut",
    // "sml_desc": "Lo Yom HaZikaron e lo Yom HaAtzmaut celebrano la storia di Israele",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/zikaronatzmaut.jpg",
    side_img: "/PostCarousel/it/zikaronatzmaut.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=47",
    isVid: false,
    css_class: "zikaronatzmaut-css",
    ctg: "telaviv",
    id: "Yom_HaZikaron_End_HaAtzmaut_It",
  },
  {
    title: "VITA NOTTURNA A TEL AVIV",
    // "sml_desc": "La città è anche uno dei luoghi più gay-friendly al mondo",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/51.jpg",
    side_img: "/PostCarousel/it/51.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=33",
    isVid: false,
    css_class: "vita-nortuna-css",
    ctg: "telaviv",
    id: "Vita_Nortuna_It",
  },
  {
    title: "AL MUSEO DELL'ARTE di TEL AVIV",
    // "sml_desc": "DUE NUOVE MOSTRE APERTE AL MUSEO DELL'ARTE di TEL AVIV",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/museotel-aviv.jpg",
    side_img: "/PostCarousel/it/museotel-aviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=79",
    isVid: false,
    css_class: "2000yearold-css-it",
    ctg: "telaviv",
    id: "Arte_Di_Telaviv_It",
  },
  {
    title: "STREET FOOD",
    // "sml_desc": "Tel Aviv: tra street food e cultura vegana",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/54.jpg",
    side_img: "/PostCarousel/it/54.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=34",
    isVid: false,
    css_class: "street-food-tlv-it",
    ctg: "telaviv",
    id: "Street_Food_It",
  },
  {
    title: "TEL AVIV, LA CITTÀ BIANCA",
    // "sml_desc": "Festegga i 100 anni del tra<br> architettura e design",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/it/53.jpg",
    side_img: "/PostCarousel/it/53.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=36",
    isVid: false,
    css_class: "la-citta-bianca-css",
    ctg: "telaviv",
    id: "La_Citta_Bianca_It",
  },
  // {
  //     "title": "LA MUSICA A TEL AVIV",
  //     // "sml_desc": "Protagonista con l'eurovision <br>song contest 2019",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/52.jpg",
  //     "side_img": "/PostCarousel/52.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=35",
  //     "isVid": false,
  //     "css_class": "la-musica-css",
  //     "ctg": "telaviv",
  //     "id": "La_Musica_A_Telaviv_It"
  // },

  // {
  //    "title": "JERUSALEM",
  //     "sml_desc" : "",
  //      "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/jerusalem.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/jerusalem.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Jerusalem",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Jerusalem"
  // },
  // {
  //     "title": "The Dead Sea",
  //     // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/DeadSea/next-level.jpg",
  //     "side_img": "/PostCarousel/DeadSea/next-level.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Next_Level_DS",
  //     "isVid": false,
  //     "ctg": "deadsea",
  //     "id": "Next_Level_DS"
  // },
  // {
  //     "title": "Tel Aviv",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/TelAviv/post-telaviv.jpg",
  //     "side_img": "/PostCarousel/TelAviv/post-telaviv.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Tel_Aviv",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     "id": "Tel_Aviv"
  // },
  // {
  //    "title": "Jerusalem’s Old City",
  //     "sml_desc" : "",
  //      // "sml_desc": "Jerusalem’s Old City",
  //      "desc" : "",
  //      // "desc": "Sensational sites of Ancient Times",
  //     "img": "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Jerusalem_Old_City",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Jerusalem_Old_City"
  // },
  // {
  //    "title": "NATURE'S GLORY",
  //     // "sml_desc": "THE DEAD SEA",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/DeadSea/natures-glory.jpg",
  //     "side_img": "/PostCarousel/DeadSea/natures-glory.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Natures_Glory",
  //     "isVid": false,
  //     "ctg": "deadsea",
  //     "id": "Natures_Glory"
  // },

  // {
  //     "title": "ALL SENSORY MARKETS",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "thingsToDo/8.jpg",
  //     "side_img": "thingsToDo/sidebar/8.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=20",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": false,
  //     "id": "All_Sensory_Markets",
  //     "showOnHome": false,
  //     "ctg": "jerusalem"

  // },

  // {
  //    "title": "Jaffa Port ",
  //     // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
  //     "sml_desc" : "",
  //     // "desc": "Tel Aviv’s fascinating cultural scene",
  //      "desc" : "",
  //     "img": "/PostCarousel/TelAviv/jaffa-port.jpg",
  //     "side_img": "/PostCarousel/TelAviv/jaffa-port.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Port_Pleasures",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     "id": "Port_Pleasures"
  // },
  // {
  //     "title": "Upscale Jerusalem",
  //     // "sml_desc": "Modern luxuries for the pampered traveler",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/Jerusalem/45.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/45.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=45",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": 45
  // },
  // {
  //    "title": "NATURAL PHENOMENA",
  //     // "sml_desc": "THE DEAD SEA",
  //      "sml_desc": "",
  //     "desc" : "",
  //     "img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
  //     "side_img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Natural_Phenomena",
  //     "isVid": false,
  //     "ctg": "deadsea",
  //     "id": "Natural_Phenomena"
  // },

  // {
  //     "title": "Tel-Aviv Highlights",
  //     // "sml_desc": "Top 5 things to see and\n do in the city",
  //      "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/17.jpg",
  //     "side_img": "/PostCarousel/17.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=17",
  //     "ctg": "telaviv",
  //     "isVid": false,
  //     "id": 17
  // },
  // {
  //     "title": "First Time in Jerusalem",
  //     // "sml_desc": "The must list for the first time visitor",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=First_Time_In_Jerusalem",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "First_Time_In_Jerusalem"
  // },
  // {
  //     "title": "Boutique Hospitality",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
  //     "side_img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Boutique_Hospitality",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     "id": "Boutique_Hospitality"
  // },

  // {
  //    "title": "SECRETS OF JEWISH JERUSALEM",
  //     "sml_desc" : "",
  //      "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Sectrets_Of_Jewish_Jerusalem",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Sectrets_Of_Jewish_Jerusalem"
  // },
  // {
  //     "title": "Non Stop Markets",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
  //     "side_img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Non_Stop_Markets",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     "id": "Non_Stop_Markets"
  // },

  // {
  //     "title": "TOWER OF DAVID MUSEUM",
  //     "sml_desc": "",
  //     "img": "thingsToDo/7.jpg",
  //     "side_img": "thingsToDo/sidebar/7.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=20",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": false,
  //     "id": "Tower_Of_David_Museum",
  //     "showOnHome": false,
  //     "ctg": "jerusalem"

  // },

  // {
  //    "title": "JERUSALEM’S ART",
  //     "sml_desc" : "",
  //     "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Jerusalem_Arts",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Jerusalem_Arts"
  // },

  // {
  //    "title": "MUST EAT IN JERUSALEM",
  //     "sml_desc" : "",
  //     "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Must_Eat_In_Jerusalem",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Must_Eat_In_Jerusalem"
  // },
  // {
  //     "title": "Tel Aviv Vegan Scene",
  //     // "sml_desc": "Voted # 1 Vegan destination in the world  ",
  //     // "desc": "Enjoy the huge choice of vegan",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "Videos/h.jpg",
  //     "img_mob":"/Videos/video_mob/h.jpg",
  //     "side_img": "Videos/sidebar/h.jpg",
  //     "vidId": "prLvetkAWwg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=6",
  //     "ctg": "culinarytelaviv",
  //     "isVid": true,
  //     "id": "Vegan_Friendly_TelAviv"
  // },

  // {
  //     "title": "UNFORGETTABLE YAD VASHEM",
  //     "sml_desc": "",
  //     "img": "thingsToDo/10.jpg",
  //     "side_img": "thingsToDo/sidebar/10.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=20",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": false,
  //     id: 31,
  //     "showOnHome": false,
  //     "ctg": "jerusalem"

  // },

  // {
  //     "title": "JERUSALEM MAIN SITES",
  //     // "sml_desc": "Travel back thousands of years",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=9",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": 99
  // },
  // {
  //     "title": "GOURMET TEL AVIV",
  //     // "sml_desc": "The perfect place\n to treat yourself",
  //     "sml_desc": "",
  //     // "desc": "Tel Aviv's huge variety of amazing",
  //     "desc": "",
  //     "img": "Videos/e.jpg",
  //     "img_mob":"/Videos/video_mob/e.jpg",
  //     "side_img": "Videos/sidebar/e.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?postType=video&post=33",
  //     "vidId": "jfyHxk8ZRrI",
  //     "ctg": "culinarytelaviv",
  //     "isVid": true,
  //     "id": "Gourmet_TelAviv"
  // },
  // {
  //     "title": "WESTERN WALL WONDERS",
  //     "sml_desc": "",
  //     "img": "thingsToDo/4.jpg",
  //     "side_img": "thingsToDo/sidebar/4.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Western_Wall_Wonders",
  //     "css_class": "unic_video-post-Western_Wall_Wonders",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": false,
  //     "id": "Western_Wall_Wonders",
  //     "ctg": "jerusalem",
  //     "showOnHome": false,

  // },
  // {
  //     "title": "Travelling on a Budget",
  //     // "sml_desc": "Making it count in Tel Aviv and Jerusalem!",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/44.jpg",
  //     "side_img": "/PostCarousel/44.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=44",
  //     "isVid": false,
  //     "ctg": "telavivAndJerusalem",
  //     "id": 44
  // },

  // {
  //    "title" : "Tel Aviv street food",
  //     // "sml_desc" : "Tel Aviv street food",
  //     "sml_desc" : "",
  //     // "desc" : "A true world-class foodie destination",
  //      "desc" : "",
  //     "img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
  //     "side_img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Tel_Aviv_Street_Food",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     "id": "Tel_Aviv_Street_Food"
  // },
  // {
  //    "title": "JERUSALEM FUN",
  //     "sml_desc" : "",
  //     "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Jerusalem_Fun",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Jerusalem_Fun"
  // },
  // {
  //     "title": "Cycle Tel Aviv",
  //     // "desc": "Get on your bicycle -<br> explore the city in style",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "PostCarousel/39.jpg",
  //     "side_img": "PostCarousel/39.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=38",
  //     "ctg": "telaviv",
  //     "isVid": false,
  //     "id": 39
  // },

  // {
  //     "title": "ULTIMATE BEACH FUN",
  //     "sml_desc": "",
  //     // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
  //     "desc": "",
  //     "img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
  //     "img_mob":"/PostCarousel/video_mob/ultimate-beaches.jpg",
  //     "side_img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=24",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": true,
  //     "id":"Ultimate_Beach_Fun",
  //     "ctg": "telaviv",
  //     "showOnHome": false,

  // },

  // {
  //     "title": "WHITE CITY SPLENDOR",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "thingsToDo/6.jpg",
  //     "side_img": "thingsToDo/sidebar/6.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=20",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": false,
  //     id: 28,
  //     "showOnHome": false,
  //     "ctg": "telaviv"

  // },
  // {
  //    "title": "Jerusalem after dark fun",
  //     "sml_desc" : "",
  //     "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Jerusalem_After_Dark_Fun",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Jerusalem_After_Dark_Fun"
  // },

  // {
  //     "title": "ALL SENSORY MARKETS",
  //     "sml_desc": "",
  //     "img": "thingsToDo/8.jpg",
  //     "side_img": "thingsToDo/sidebar/8.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=20",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": false,
  //     "id": "All_Sensory_Markets",
  //     "showOnHome": false,
  //     "ctg": "culinary"

  // },

  // {
  //     "title": "Party Capital",
  //     // "sml_desc": "Epic Nights in the non stop city",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/42.jpg",
  //     "side_img": "/PostCarousel/42.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=42",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     "id": "Party_Capital"
  // },

  // Eilat Posts
  // {
  //  "title":"EILAT",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/eilat1.jpg",
  //  "side_img":"/PostCarousel/eilat1.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=EILAT1",
  //  "css_class":"unic-post-EILAT1",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'EILAT1'
  // },
  // {
  //  "title":"Welcome to Eilat",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/welcome-to-eilat.jpg",
  //  "side_img":"/PostCarousel/welcome-to-eilat.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Welcome_To_Eilat",
  //  "css_class":"unic-post-welcome-to-eilat",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Welcome_To_Eilat'
  // },
  // {
  //  "title":"THE ULTIMATE HOLIDAY",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/the-ultimate-holiday.jpg",
  //  "side_img":"/PostCarousel/the-ultimate-holiday.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=The_Ultimate_Holiday",
  //  "css_class":"unic-post-the-ultimate-holiday",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'The_Ultimate_Holiday'
  // },
  {
    title: "Neot Semadar",
    sml_desc: "",
    desc: "",
    img: "PostCarousel/Neot_Semadar.jpg",
    side_img: "PostCarousel/Neot_Semadar.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Neot_Semadar",
    css_class: "unic-post-Neot-Semadar",
    isVid: false,
    // vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Neot_Semadar",
  },
  {
    title: "UNA SENSAZIONE DI VACANZA ESTIVA SENZA FINE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-calling.jpg",
    side_img: "/PostCarousel/eilat-calling.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Calling",
    css_class: "unic-post-eilat-calling",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Eilat_Calling",
  },
  {
    title: "LA SPIAGGIA DEI DELFINI DI EILAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-doolphin-reef.jpg",
    side_img: "/PostCarousel/eilat-doolphin-reef.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Doolphin_Reef",
    css_class: "unic-post-eilat-doolphin-reef",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Eilat_Doolphin_Reef",
  },
  // {
  //  "title":"Action Packed Eilat",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/action-packed-eilat.jpg",
  //  "side_img":"/PostCarousel/action-packed-eilat.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Action_Packed_Eilat",
  //  "css_class":"unic-post-action-packed-eilat",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Action_Packed_Eilat'
  // },
  {
    title: "LASCIATI ANDARE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    side_img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Ultimate_Beachside",
    css_class: "unic-post-eilat-ultimate-beachside",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Eilat_Ultimate_Beachside",
  },
  // {
  //  "title":"One Day in Eilat",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/one-day-in-eilat.jpg",
  //  "side_img":"/PostCarousel/one-day-in-eilat.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=One_Day_In_Eilat",
  //  "css_class":"unic-post-one-day-in-eilat",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'One_Day_In_Eilat'
  // },
  // {
  //  "title":"ISRAEL’S MAJESTIC DESERT",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/majestic-desert.jpg",
  //  "side_img":"/PostCarousel/majestic-desert.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Majestic_Desert",
  //  "css_class":"unic-post-majestic-desert",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Majestic_Desert'
  // },
  // {
  //  "title":"Negev",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/negev.jpg",
  //  "side_img":"/PostCarousel/negev.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Negev1",
  //  "css_class":"unic-post-negev",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Negev1'
  // },
  // {
  //  "title":"LOCATION AND APPROACH",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/location-and-approach.jpg",
  //  "side_img":"/PostCarousel/location-and-approach.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Location_And_Approach",
  //  "css_class":"unic-post-location-and-approach",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Location_And_Approach'
  // },
  {
    title: "SISTEMAZIONI NEL NEGEV",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/stay-in-the-negev.jpg",
    side_img: "/PostCarousel/stay-in-the-negev.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Stay_In_The_Negev",
    css_class: "unic-post-stay-in-the-negev",
    isVid: false,
    ctg: "eilat-negev",
    id: "Stay_In_The_Negev",
  },
  {
    title: "PURA MAGIA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/pure-desert-magic.jpg",
    side_img: "/PostCarousel/pure-desert-magic.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Pure_Desert_Magic",
    css_class: "unic-post-pure-desert-magic",
    isVid: false,
    ctg: "eilat-negev",
    id: "Pure_Desert_Magic",
  },
  {
    title: "DIVERTIMENTO E AZIONE NEL DESERTO ISRAELIANO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/action-fun-in-the-desert.jpg",
    side_img: "/PostCarousel/action-fun-in-the-desert.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Action_Fun_In_The_Desert",
    css_class: "unic-post-action-fun-in-the-desert",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Action_Fun_In_The_Desert",
  },
  {
    title: "LA VIA DELL’INCENSO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/the-incense-route.jpg",
    side_img: "/PostCarousel/the-incense-route.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Incense_Route",
    css_class: "unic-post-the-incense-route",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "The_Incense_Route",
  },
  // {
  //  "title":"Mount Karkom",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/mount-karkom.jpg",
  //  "side_img":"/PostCarousel/mount-karkom.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Mount_Karkom",
  //  "css_class":"unic-post-mount-karkom",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Mount_Karkom'
  // },
  {
    title: "L’ARAVA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/ha-arava.jpg",
    side_img: "/PostCarousel/ha-arava.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Ha_Arava",
    css_class: "unic-post-ha-arava",
    isVid: false,
    ctg: "eilat-negev",
    id: "Ha_Arava",
  },
  // {
  //  "title":"Machtesh Ramon",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/machtes-ramon.jpg",
  //  "side_img":"/PostCarousel/machtes-ramon.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Machtesh_Ramon",
  //  "css_class":"unic-post-machtes-ramon",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Machtesh_Ramon'
  // },
  {
    title: "SCOPRI MASADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/epic-masada.jpg",
    side_img: "/PostCarousel/epic-masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Epic_Masada",
    css_class: "unic-post-epic-masada",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Epic_Masada",
  },
  // {
  //  "title":"The Bedouin Experience",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/the-bedouin-experience.jpg",
  //  "side_img":"/PostCarousel/the-bedouin-experience.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=The_Bedouin_Experience",
  //  "css_class":"unic-post-the-bedouin-experience",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'The_Bedouin_Experience'
  // },
  // {
  //  "title":"The Israel National Trail",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/the-israel-national-trail.jpg",
  //  "side_img":"/PostCarousel/the-israel-national-trail.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=The_Israel_National_Trail",
  //  "css_class":"unic-post-the-israel-national-trail",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'The_Israel_National_Trail'
  // },
  {
    title: "PARCO DI TIMNA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/timna-treasures.jpg",
    side_img: "/PostCarousel/timna-treasures.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Timna_Treasures",
    css_class: "unic-post-timna-treasures",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Timna_Treasures",
  },
  {
    title: "DESERTO DEL NEGEV",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/negev-desert-dont-miss.jpg",
    side_img: "/PostCarousel/negev-desert-dont-miss.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Negev_Desert_Dont_Miss",
    css_class: "unic-post-negev-desert-dont-miss",
    isVid: false,
    ctg: "eilat-negev",
    id: "Negev_Desert_Dont_Miss",
  },
  // {
  //  "title":"NEGEV CHARMS",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/negev-charms.jpg",
  //  "side_img":"/PostCarousel/negev-charms.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Negev_Charms",
  //  "css_class":"unic-post-negev-charms",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Negev_Charms'
  // },
  // End Eilat Posts

  // North Posts
  // {
  //  "title":"Galilee",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/galilee.jpg",
  //  "side_img":"/PostCarousel/galilee.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Galilee",
  //  "css_class":"unic-post-galilee",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'Galilee'
  // },
  // {
  //  "title":"Caesarea",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/caesarea.jpg",
  //  "side_img":"/PostCarousel/caesarea.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Caesarea",
  //  "css_class":"unic-post-caesarea",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'Caesarea'
  // },
  {
    title: "ACRI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/acre.jpg",
    side_img: "/PostCarousel/acre.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Acre",
    css_class: "unic-post-acre",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Acre",
  },
  {
    title: "HAIFA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/haifa.jpg",
    side_img: "/PostCarousel/haifa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Haifa",
    css_class: "unic-post-haifa",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Haifa",
  },

  {
    title: "Nazareth",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/nazareth.jpg",
    side_img: "/PostCarousel/nazareth.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nazareth",
    css_class: "unic-post-nazareth",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Nazareth",
  },

  // These two posts is for complite the 4 post in carousel in mobile for JERUSALEM carousel
  {
    title: "I must di Gerusalemme",
    // "sml_desc": "Le 5 cose da fare e vedere<br> in questa incantevole città",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/18.jpg",
    side_img: "/PostCarousel/18.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_Musts",
    isVid: false,
    forVidPage: true,
    isDouble: true,
    ctg: "jerusalem",
    id: "Jerusalem_Musts",
  },
  {
    title: "Una città magica di splendore",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/6.jpg",
    side_img: "/PostCarousel/Jerusalem/6.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Magic_City_Of_Splender",
    isVid: false,
    forVidPage: true,
    isDouble: true,
    ctg: "jerusalem",
    id: "Magic_City_Of_Splender",
  },

  // END These two posts is for complite the 4 post in carousel in mobile for JERUSALEM carousel

  // This post is for complite the 4 post in carousel in mobile for TEL AVIV carousel
  {
    title: "Wine Festival",
    // "sml_desc": "Con Wine&Plenty alla scoperta dei vini israeliani",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/wine_festival.jpg",
    side_img: "/PostCarousel/wine_festival.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=51",
    isVid: false,
    isDouble: true,
    css_class: "wine-festival-it-css",
    ctg: "telaviv",
    id: "Wine_Festival_It",
  },
  // END This post is for complite the 4 post in carousel in mobile for TEL AVIV carousel

  //These two posts is for complite the 4 post in carousel in mobile for CUILINARY carousel
  {
    title: "La cucina di Gerusalemme",
    sml_desc: "",
    // "desc": "Esaltante e varia…deliziosa!",
    desc: "",
    img: "PostCarousel/Culinary/cuisine-jer.jpg",
    img_mob: "/PostCarousel/video_mob/cuisine-jer.jpg",
    side_img: "PostCarousel/Culinary/cuisine-jer.jpg",
    read_more: "READ MORE",
    vidId: "2CSCe2WC7Ns",
    link: "/Posts/index.php?post=13",
    ctg: "culinaryjerusalem",
    isVid: true,
    forVidPage: true,
    isDouble: true,
    id: "Jerusalem_Cuisine",
  },

  {
    title: "Cosa mangiare a Gerusalemme",
    // "sml_desc": "Must eat dishes to try when visiting the magical city",
    desc: "",
    sml_desc: "",
    img: "/PostCarousel/37.jpg",
    img_mob: "/PostCarousel/video_mob/37.jpg",
    side_img: "/PostCarousel/37.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=38",
    ctg: "culinaryjerusalem",
    vidId: "2CSCe2WC7Ns",
    isVid: true,
    forVidPage: true,
    isDouble: true,
    id: "A_Taste_Of_Jerusalem",
  },
  // END These two posts is for complite the 4 post in carousel in mobile for CUILINARY carousel

  //These tree posts is for complite the 4 post in carousel in mobile for DEAD SEA carousel
  {
    title: "Il Mar Morto",
    // "sml_desc": "È giunto il momento di rilassarsi nella natura",
    sml_desc: "",
    desc: "",
    // "desc": "Goditi la vita nel luogo più basso della Terra",
    img: "/PostCarousel/DeadSea/natural-spa.jpg",
    img_mob: "/PostCarousel/video_mob/natural-spa.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=2",
    isVid: true,
    forVidPage: true,
    isDouble: true,
    vidId: "Kmq8NulV8Mo",
    ctg: "deadsea",
    id: "Dead_Sea2",
  },
  {
    title: "SCOPRI MASADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/masada.jpg",
    side_img: "/PostCarousel/DeadSea/masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Masada",
    isVid: true,
    vidId: "xH9m5hfimNQ",
    forVidPage: true,
    isDouble: true,
    ctg: "deadsea",
    id: "Masada",
  },
  {
    title: "MAR MORTO",
    sml_desc: "",
    // "sml_desc": "THE DEAD SEA",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-spa2.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natural_Spa",
    isVid: true,
    vidId: "8p4qfkneH1c",
    forVidPage: true,
    isDouble: true,
    ctg: "deadsea",
    id: "Natural_Spa2",
  },
  // END These tree posts is for complite the 4 post in carousel in mobile for DEAD SEA carousel

  // This post is for complite the 4 post in carousel in mobile for NEGEV AND EILAT carousel
  {
    title: "DIVERTIMENTO E AZIONE NEL DESERTO ISRAELIANO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/action-fun-in-the-desert.jpg",
    side_img: "/PostCarousel/action-fun-in-the-desert.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Action_Fun_In_The_Desert",
    css_class: "unic-post-action-fun-in-the-desert",
    isVid: false,
    forVidPage: true,
    isDouble: true,
    ctg: "eilat-negev",
    id: "Action_Fun_In_The_Desert",
  },
  // END this post is for complite the 4 post in carousel in mobile for NEGEV AND EILAT carousel

  // These tree posts is for complite the 4 post in carousel in mobile for NORTH carousel
  {
    title: "Cesarea",
    // "sml_desc": "Alla scoperta di Cesarea, storia millenaria e acque cristalline",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/cesarea.jpg",
    side_img: "/PostCarousel/cesarea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=42",
    isVid: false,
    isDouble: true,
    css_class: "cesarea-css-it",
    ctg: "north",
    id: "Cesarea_It",
  },
  {
    title: "Zichron Ya’akov",
    // "sml_desc": "Zichron Ya’akov, alla scoperta della città tra vino e natura",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/zichron_yaakov.jpg",
    side_img: "/PostCarousel/zichron_yaakov.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=52",
    isVid: false,
    isDouble: true,
    css_class: "zichron_yaakov-it-css",
    ctg: "north",
    id: "Zichron_Yakov_It",
  },
  {
    title: "HAIFA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/haifa.jpg",
    side_img: "/PostCarousel/haifa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Haifa",
    css_class: "unic-post-haifa",
    isVid: false,
    isDouble: true,
    forVidPage: true,
    ctg: "north",
    id: "Haifa",
  },
  // END These tree posts is for complite the 4 post in carousel in mobile for NORTH carousel
];

export const newVideos = [
  //this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked
  {
    title: "Alla ricerca di una folle vita notturna?",
    // "sml_desc": "Prenota il tuo viaggio a Tel Aviv adesso!",
    sml_desc: "",
    // "desc": "",
    desc: "",
    img: "Videos/crazy-night.jpg",
    img_mob: "/Videos/video_mob/crazy-night.jpg",
    side_img: "Videos/sidebar/crazy-night.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=8",
    vidId: "ogEN7aRT0SM",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "Amazing_Nightlife",
  },
  // END this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked

  {
    title: "Gerusalemme",
    // "sml_desc": "Gerusalemme: il cuore del mondo",
    sml_desc: "",
    // "desc": "",
    desc: "",
    img: "Videos/heart-of-the-world.jpg",
    img_mob: "/Videos/video_mob/heart-of-the-world.jpg",
    side_img: "Videos/sidebar/heart-of-the-world.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Heart_Of_The_World",
    vidId: "nLKWDp5uA-U",
    ctg: "jerusalem",
    isVid: true,
    forVidPage: true,
    id: "Heart_Of_The_World",
  },

  {
    title: "MAGICA GIAFFA",
    sml_desc: "",
    // "sml_desc" : "GIAFFA: una città dal fascino multiculturale",
    desc: "",
    // "desc" : "Scopri tutte le ricchezze che la stupenda Giaffa antica può offrire",
    img: "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
    img_mob: "/PostCarousel/video_mob/joys-of-jaffa.jpg",
    side_img: "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=6",
    isVid: true,
    forVidPage: true,
    vidId: "xz05_8hA4q4",
    ctg: "telaviv",
    id: "Joys_Of_Jaffa",
  },
  {
    title: "Il Mar Morto",
    // "sml_desc": "È giunto il momento di rilassarsi nella natura",
    sml_desc: "",
    desc: "",
    // "desc": "Goditi la vita nel luogo più basso della Terra",
    img: "/PostCarousel/DeadSea/natural-spa.jpg",
    img_mob: "/PostCarousel/video_mob/natural-spa.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=2",
    isVid: true,
    forVidPage: true,
    vidId: "Kmq8NulV8Mo",
    ctg: "deadsea",
    id: "Dead_Sea2",
  },
  {
    title: "TEL AVIV SUL MARE",
    // "sml_desc": "Perché a Tel Aviv la vita è una spiaggia ",
    sml_desc: "",
    // "desc": "Preparati a divertirti alla grande sotto il sole",
    desc: "",
    img: "Videos/a.jpg",
    img_mob: "/Videos/video_mob/a.jpg",
    side_img: "Videos/sidebar/a.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=3",
    css_class: "unic_video-post-4",
    vidId: "BEmvshdB1ao",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "TelAviv_By_The_Sea",
  },

  {
    title: "Sarona Tel Aviv",
    desc: "",
    // "desc": "Un’enorme scelta di attrazioni in  una colonia templare incredibilmente rinnovata",
    // "sml_desc": "Un’incredibile oasi urbana",
    sml_desc: "",
    img: "Videos/d.jpg",
    img_mob: "/Videos/video_mob/d.jpg",
    side_img: "Videos/sidebar/d.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=1",
    vidId: "XFgR0acFwF4",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "Sarona_TelAviv",
  },
  {
    title: "I piaceri del porto",
    // "sml_desc": "I diversi fascini dei <br>porti di Tel Aviv e di Jaffa ",
    sml_desc: "",
    // "desc": "I piaceri del porto",
    desc: "",
    img: "/PostCarousel/TelAviv/3.jpg",
    img_mob: "/PostCarousel/video_mob/3.jpg",
    side_img: "/PostCarousel/TelAviv/3.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Port_Pleasures",
    isVid: true,
    forVidPage: true,
    vidId: "xz05_8hA4q4",
    ctg: "telaviv",
    id: "Port_Pleasures",
  },

  {
    title: "Neve Tzedek",
    sml_desc: "",
    // "sml_desc" : "Chic ed esclusiva",
    // "desc": "Ricca di bellissimi caffè, boutique, gallerie d’arte, eleganza e vitalità",
    desc: "",
    img: "Videos/j.jpg",
    img_mob: "/Videos/video_mob/j.jpg",
    side_img: "Videos/sidebar/j.jpg",
    read_more: "READ MORE",
    vidId: "R0QsWBZfIpU",
    link: "/Posts/index.php?postType=video&post=7",
    css_class: "unic_video-post-13",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "Neve_Tzedek",
  },

  {
    title: "Gerusalemme vecchia e nuova",
    // "sml_desc": "Tesori antichi e lusso moderno",
    sml_desc: "",
    desc: "",
    // "desc": "Un’entusiasmante avventura a Gerusalemme, una città incredibile",
    img: "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    img_mob: "/PostCarousel/video_mob/jerusalem-old-city.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=8",
    css_class: "old-new-jer",
    isVid: true,
    forVidPage: true,
    vidId: "3g9T1HMP39Q",
    ctg: "jerusalem",
    id: "New_And_OLd_Jerusalem",
  },

  {
    title: "La città vecchia",
    sml_desc: "",
    // "sml_desc": "Senti la storia che prende vita",
    desc: "",
    // "desc": "Fatti ispirare dai famosi tesori dell’antica città di Gerusalemme",
    img: "Videos/m.jpg",
    img_mob: "/Videos/video_mob/m.jpg",
    side_img: "Videos/sidebar/m.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=4",
    isVid: true,
    forVidPage: true,
    vidId: "RwzdqkM3_CU",
    ctg: "jerusalem",
    id: "Jerusalem_Old_City",
  },

  {
    title: "Tel Aviv su due ruote",
    // "sml_desc" : "Avventure all’aperto",
    sml_desc: "",
    desc: "Una città ricca di azione – perfetta per persone attive",
    side_img: "PostCarousel/TelAviv/tlv-on-wheels.jpg",
    img_mob: "/PostCarousel/video_mob/tlv-on-wheels.jpg",
    img: "PostCarousel/TelAviv/tlv-on-wheels.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "page-telaviv-adventures",
    ctg: "telaviv",
    vidId: "-eNQe5STaGY",
    isVid: true,
    forVidPage: true,
    id: "TelAviv_On_Wheels",
  },

  {
    title: "Il Mar Morto ",
    // "sml_desc": "È giunto il momento di rilassarsi nella natura",
    sml_desc: "",
    // "desc": "Goditi la vita nel luogo più basso della Terra  ",
    desc: "",
    img: "/PostCarousel/DeadSea/natures-glory.jpg",
    img_mob: "/PostCarousel/video_mob/natures-glory.jpg",
    side_img: "/PostCarousel/DeadSea/natures-glory.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Dead_Sea_Video",
    isVid: true,
    forVidPage: true,
    ctg: "deadsea2",
    vidId: "ixFocykfYHo",
    id: "Dead_Sea_Video",
  },

  {
    title: "2  fantastiche città",
    // "sml_desc": "Una magica e indimenticabile fuga verso il sole",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    side_img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=42",
    isVid: true,
    vidId: "CV2TtpIHrrk",
    forVidPage: true,
    ctg: "telavivAndJerusalem",
    id: "2_AWESOME_CITIES",
  },

  {
    title: "Divertimento nonstop",
    // "sml_desc": "Bellissima, colorata ed eccitante – Fantastica Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    side_img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nonstop_Excitement",
    ctg: "telaviv",
    isVid: true,
    vidId: "88OV6xU0vPI",
    forVidPage: true,
    id: "Nonstop_Excitement",
  },
  {
    title: "Gerusalemme ti chiama",
    // "sml_desc": "La città più magica<br> e splendida sulla Terra",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/4.jpg",
    side_img: "/PostCarousel/4.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=4",
    ctg: "jerusalem",
    isVid: true,
    vidId: "1Yx2Uht4rms",
    forVidPage: true,
    id: "Jerusalem_Calling",
  },

  {
    title: "SCOPRI MASADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/masada.jpg",
    side_img: "/PostCarousel/DeadSea/masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Masada",
    isVid: true,
    vidId: "xH9m5hfimNQ",
    forVidPage: true,
    ctg: "deadsea",
    id: "Masada",
  },

  {
    title: "Una meta per lo shopping",
    // "sml_desc": "Dalla moda ai souvenir, Gerusalemme ha tutto",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/5.jpg",
    side_img: "/PostCarousel/5.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Shopping_Delights",
    ctg: "jerusalem",
    isVid: true,
    vidId: "3g9T1HMP39Q",
    forVidPage: true,
    id: "Shopping_Delights",
  },

  {
    title: "Incredibile vita notturna",
    sml_desc: "",
    // "sml_desc": "Incredibile vita notturna",
    desc: "",
    // "desc": "Una festa senza fine nella<br> città che non si ferma mai!",
    img: "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    side_img: "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Amazing_Nightlife",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    forVidPage: true,
    ctg: "telaviv",
    id: "Amazing_Nightlife",
  },

  {
    title: "LUOGHI IMPORTANTI DI GERUSALEMME",
    sml_desc: "",
    // "desc": "Lo spirito di Gerusalemme",
    desc: "",
    img: "PostCarousel/Jerusalem/main-sites-jer.jpg",
    side_img: "PostCarousel/Jerusalem/main-sites-jer.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=9",
    ctg: "jerusalem",
    css_class: "page-jerusalem-mainsites",
    isVid: true,
    vidId: "k4OwoEk5wMw",
    forVidPage: true,
    id: "Jerusalem_Main_Sites",
  },

  //Hadar asked to hide the video in this post on 18.01.2021
  // {
  //    "title" : "Spazio alla cultura",
  //     // "sml_desc": "Spazio alla cultura",
  //     "sml_desc" : "",
  //     // "desc": "Una grande varietà di affascinanti musei e gallerie uniche",
  //      "desc" : "",
  //     "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
  //     "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Non_Stop_Culture",
  //     "isVid": false,
  //     "vidId" : "MXtcTm_JXus",
  //     "forVidPage": true,
  //     "ctg": "telaviv",
  //     "id": "Non_Stop_Culture"
  // },
  // End Hadar asked to hide the video in this post on 18.01.2021
  {
    title: "Spiagge sensazionali",
    // "sml_desc": "Vieni a rilassarti sulle assolate spiagge di Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/sensational-beaches2.jpg",
    side_img: "/PostCarousel/TelAviv/sensational-beaches2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=14",
    isVid: true,
    vidId: "XDei1Zy_cu4",
    forVidPage: true,
    ctg: "telaviv",
    //"id": 14
    id: "Sensational_Beaches",
  },

  {
    title: "I must di Tel Aviv",
    sml_desc: "",
    desc: "Le 5 cose da fare e vedere in città",
    img: "/PostCarousel/17.jpg",
    side_img: "/PostCarousel/17.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=17",
    ctg: "telaviv",
    css_class: "page-telaviv-highlights",
    isVid: true,
    vidId: "R0QsWBZfIpU",
    forVidPage: true,
    id: "TelAviv_Highlights",
  },

  {
    title: "Moderna e vivace",
    // "sml_desc": "C’è tanto da vedere nel<br> vivace centro di Gerusalemme",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/19.jpg",
    side_img: "/PostCarousel/19.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Modern_And_Vibrant",
    isVid: true,
    vidId: "MXtcTm_JXus",
    forVidPage: true,
    ctg: "jerusalem",
    id: "Modern_And_Vibrant",
  },

  {
    title: "I must di Gerusalemme",
    // "sml_desc": "Le 5 cose da fare e vedere<br> in questa incantevole città",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/18.jpg",
    side_img: "/PostCarousel/18.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_Musts",
    isVid: true,
    vidId: "WVGEqXhtipI",
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem_Musts",
  },

  {
    title: "MAR MORTO",
    sml_desc: "",
    // "sml_desc": "THE DEAD SEA",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-spa2.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natural_Spa",
    isVid: true,
    vidId: "8p4qfkneH1c",
    forVidPage: true,
    ctg: "deadsea",
    id: "Natural_Spa2",
  },

  {
    title: "Girare in bici a Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "PostCarousel/39.jpg",
    side_img: "PostCarousel/39.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=31",
    ctg: "telaviv",
    css_class: "page-telaviv-cycle",
    isVid: true,
    vidId: "88OV6xU0vPI",
    forVidPage: true,
    id: "Cycle_TelAviv",
  },

  {
    title: "Le sorprese di Gerusalemme",
    // "sml_desc": "Una città che supera le aspettative",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/38.jpg",
    side_img: "/PostCarousel/38.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Cool_Jerusalem",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    forVidPage: true,
    id: "Cool_Jerusalem",
  },

  {
    title: "Una città magica di splendore",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/6.jpg",
    side_img: "/PostCarousel/Jerusalem/6.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Magic_City_Of_Splender",
    isVid: true,
    vidId: "RwzdqkM3_CU",
    forVidPage: true,
    ctg: "jerusalem",
    id: "Magic_City_Of_Splender",
  },

  {
    title: "VIALE MAMILLA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    side_img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Mamilla_Avenue",
    isVid: true,
    vidId: "3g9T1HMP39Q",
    forVidPage: true,
    ctg: "jerusalem",
    id: "Mamilla_Avenue",
  },
  {
    title: "LE PORTE DI GERUSALEMME",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/gates.jpg",
    side_img: "/PostCarousel/Jerusalem/gates.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Gates_Of_Jerusalem",
    isVid: true,
    vidId: "MXtcTm_JXus",
    forVidPage: true,
    ctg: "jerusalem",
    id: "The_Gates_Of_Jerusalem",
  },
  {
    title: "IL MAR MORTO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/magical-deadsea2.jpg",
    side_img: "/PostCarousel/DeadSea/magical-deadsea2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Magical_Deadsea",
    isVid: true,
    vidId: "Kmq8NulV8Mo",
    forVidPage: true,
    ctg: "deadsea",
    id: "Magical_Deadsea",
  },
  {
    title: "UNA SENSAZIONE DI VACANZA ESTIVA SENZA FINE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-calling.jpg",
    side_img: "/PostCarousel/eilat-calling.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Calling",
    css_class: "unic-post-eilat-calling",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Eilat_Calling",
  },
  {
    title: "LA SPIAGGIA DEI DELFINI DI EILAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-doolphin-reef.jpg",
    side_img: "/PostCarousel/eilat-doolphin-reef.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Doolphin_Reef",
    css_class: "unic-post-eilat-doolphin-reef",
    isVid: true,
    vidId: "EPAPO5zU--4",
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Eilat_Doolphin_Reef",
  },

  {
    title: "DIVERTIMENTO E AZIONE NEL DESERTO ISRAELIANO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/action-fun-in-the-desert.jpg",
    side_img: "/PostCarousel/action-fun-in-the-desert.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Action_Fun_In_The_Desert",
    css_class: "unic-post-action-fun-in-the-desert",
    isVid: true,
    vidId: "yXzhH92kREg",
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Action_Fun_In_The_Desert",
  },
  {
    title: "LA VIA DELL’INCENSO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/the-incense-route.jpg",
    side_img: "/PostCarousel/the-incense-route.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Incense_Route",
    css_class: "unic-post-the-incense-route",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    forVidPage: true,
    ctg: "eilat-negev",
    id: "The_Incense_Route",
  },

  {
    title: "SCOPRI MASADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/epic-masada.jpg",
    side_img: "/PostCarousel/epic-masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Epic_Masada",
    css_class: "unic-post-epic-masada",
    isVid: true,
    vidId: "xH9m5hfimNQ",
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Epic_Masada",
  },
  {
    title: "LASCIATI ANDARE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    side_img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Ultimate_Beachside",
    css_class: "unic-post-eilat-ultimate-beachside",
    isVid: true,
    vidId: "Kmq8NulV8Mo",
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Eilat_Ultimate_Beachside",
  },

  {
    title: "PARCO DI TIMNA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/timna-treasures.jpg",
    side_img: "/PostCarousel/timna-treasures.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Timna_Treasures",
    css_class: "unic-post-timna-treasures",
    isVid: true,
    vidId: "yXzhH92kREg",
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Timna_Treasures",
  },

  {
    title: "ACRI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/acre.jpg",
    side_img: "/PostCarousel/acre.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Acre",
    css_class: "unic-post-acre",
    isVid: true,
    vidId: "J0MjPKAmQRg",
    forVidPage: true,
    ctg: "north",
    id: "Acre",
  },
  {
    title: "HAIFA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/haifa.jpg",
    side_img: "/PostCarousel/haifa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Haifa",
    css_class: "unic-post-haifa",
    isVid: true,
    forVidPage: true,
    vidId: "DAM1o7WW8ck",
    ctg: "north",
    id: "Haifa",
  },

  {
    title: "Nazareth",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/nazareth.jpg",
    side_img: "/PostCarousel/nazareth.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nazareth",
    css_class: "unic-post-nazareth",
    isVid: true,
    vidId: "nVJe3bBdMn4",
    forVidPage: true,
    ctg: "north",
    id: "Nazareth",
  },

  // These three posts is for complite the 4 post in carousel in mobile for THINGS TO DO carousel
  {
    title: "La città vecchia",
    sml_desc: "",
    // "sml_desc": "Senti la storia che prende vita",
    desc: "",
    // "desc": "Fatti ispirare dai famosi tesori dell’antica città di Gerusalemme",
    img: "Videos/m.jpg",
    img_mob: "/Videos/video_mob/m.jpg",
    side_img: "Videos/sidebar/m.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=4",
    isVid: true,
    forVidPage: true,
    isDouble: true,
    vidId: "RwzdqkM3_CU",
    ctg: "jerusalem",
    id: "Jerusalem_Old_City",
  },
  {
    title: "Spazio alla cultura",
    // "sml_desc": "Spazio alla cultura",
    sml_desc: "",
    // "desc": "Una grande varietà di affascinanti musei e gallerie uniche",
    desc: "",
    img: "/PostCarousel/TelAviv/culture-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/culture-telaviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Non_Stop_Culture",
    isVid: true,
    vidId: "MXtcTm_JXus",
    isDouble: true,
    forVidPage: true,
    ctg: "telaviv",
    id: "Non_Stop_Culture",
  },
  {
    title: "MAR MORTO",
    sml_desc: "",
    // "sml_desc": "THE DEAD SEA",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-spa2.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natural_Spa",
    isVid: true,
    vidId: "8p4qfkneH1c",
    forVidPage: true,
    isDouble: true,
    ctg: "deadsea",
    id: "Natural_Spa2",
  },
  // End These three posts is for complite the 4 post in carousel in mobile for THINGS TO DO carousel
];

export const TouristInfoPosts = [
  {
    title: "COSA METTERE NELLA VALIGIA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/what-to-pack.jpg",
    side_img: "/PostCarousel/what-to-pack.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-what-to-pack",
    isVid: false,
    ctg: "TouristInfo",
    id: "What_To_Pack",
  },
  // {
  //  "title":"Electrical Appliances",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/electrical-appliances.jpg",
  //  "side_img":"/PostCarousel/electrical-appliances.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=20",
  //  "css_class":"unic-post-electrical-appliances",
  //  "isVid" : false,
  //  "ctg"   : 'TouristInfo',
  //   "id"    : 'Electrical_Appliances'
  // },
  {
    title: "METEO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/weather.jpg",
    side_img: "/PostCarousel/weather.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-weather",
    isVid: false,
    ctg: "TouristInfo",
    id: "Weather",
  },
  {
    title: "TRASPORTI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/transportation.jpg",
    side_img: "/PostCarousel/transportation.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-transportation",
    isVid: false,
    ctg: "TouristInfo",
    id: "Transportation",
  },
  {
    title: "DOMANDE FREQUENTI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/faq.jpg",
    side_img: "/PostCarousel/faq.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-faq",
    isVid: false,
    ctg: "TouristInfo",
    id: "Frequently_Asked_Questions",
  },

  {
    title: "VALUTA ISRAELIANA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/israeli-currency.jpg",
    side_img: "/PostCarousel/israeli-currency.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-israeli-currency",
    isVid: false,
    ctg: "TouristInfo",
    id: "Israeli_Currency",
  },
  // {
  //  "title":"Immigration Customs",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/immigration-customs.jpg",
  //  "side_img":"/PostCarousel/immigration-customs.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=20",
  //  "css_class":"unic-post-immigration-customs",
  //  "isVid" : false,
  //  "ctg"   : 'TouristInfo',
  //   "id"    : 'Immigration_Customs'
  // },
  {
    title: "PASSAPORTI E VISTI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Passports-visa.jpg",
    side_img: "/PostCarousel/Passports-visa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-Passports-visa",
    isVid: false,
    ctg: "TouristInfo",
    id: "Passports_Visa",
  },

  {
    title: "UNA META PER TUTTI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/PlanYourTrip/destination-for-all.jpg",
    side_img: "/PostCarousel/PlanYourTrip/destination-for-all.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-Passports-visa",
    isVid: false,
    forVidPage: true,
    ctg: "TouristInfo",
    id: "Destination_For_All",
  },
];

export const Reminders = [
  // Tel Aviv
  {
    quote: "One of the world's 25 best cities for foodies",
    site: "Business Insider",
    img: "/References/1.jpg",
    ctg: "Tel Aviv",
  },

  // Jerusalem
  {
    quote: "TripAdvisor Traveler's Choice Award 2015",
    site: "TripAdvisor",
    img: "/References/9.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the world's leading party cities",
    site: "Telegraph",
    img: "/References/2.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "One of the cities with most beautiful people",
    site: "Conde Nast",
    img: "/References/3.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "One of the 20 must visit destinations in the world  TNS",
    site: "The National Student",
    img: "/References/10.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the best beach party spots on the planet",
    site: "USA Today",
    img: "/References/4.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote: "One of the world's top 10 beach cities",
    site: "National Geographic",
    img: "/References/5.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "3rd Of 6 Top world’s holiest sites",
    site: "National Geographic",
    img: "/References/11.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the world's top ten cities",
    site: "Lonely Planet",
    img: "/References/6.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote: "One of the world's top ten hedonistic city breaks ",
    site: "Lonely Planet",
    img: "/References/7.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote:
      "I just thought it was magical… It instantly turned into my favorite trip.",
    site: "TripAdvisor",
    img: "/References/12.jpg",
    ctg: "Jerusalem",
    job: "CEO, Stephen Kaufer about Jerusalem",
    cssClass: "make-it-smller",
  },

  {
    quote: "The World’s New Dining Hotspot",
    site: "Bloomberg.com",
    img: "/References/8.jpg",
    ctg: "Tel Aviv",
  },
];



// WEBPACK FOOTER //
// ./src/Data/Data.js